// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:38:20.436Z
// Property: Double Tree Apts. (ID: 6767906449165604)
// Collections: 29 amenities, 4 floorplans (live), 43 photos, 69 POIs, 3 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165604",
  "property_external_id": "8zs2e12",
  "property_zillow_url": "https://www.zillow.com/b/double-tree-el-paso-tx-5XmBfY/",
  "property_apartments_url": "https://www.apartments.com/double-tree-apts-el-paso-tx/8zs2e12/",
  "property_google_business_url": "https://www.google.com/maps/place/Double+Tree+Apartments/data=!4m2!3m1!1s0x0:0x122a25eb9a0993e1?sa=X&ved=2ahUKEwjnsJHp-LySAxU6SjABHbG7AxgQ_BJ6BAg7EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "double-tree-apts.",
  "property_name": "Double Tree Apts.",
  "property_website_url": "https://www.caseusa.com/apartments/tx/el-paso/double-tree/",
  "property_domain": null,
  "property_address": "200 North Mesa Hills Drive",
  "property_full_address": "200 North Mesa Hills Drive, El Paso, TX, 79912",
  "property_address_1": "200 North Mesa Hills Drive",
  "property_address_2": null,
  "property_address_city": "El Paso",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "79912",
  "property_address_country": "US",
  "property_address_county": "El Paso County",
  "property_neighborhood_address": "Upper Mesa Hills",
  "property_address_latitude": "31.8249",
  "property_address_longitude": "-106.51866",
  "property_email": "doubletree@caseusa.com",
  "property_phone": "(915) 335-6857",
  "property_call_tracking_phone": "833-649-1986",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Double Tree Apts., where comfort meets convenience in El Paso, Texas. Choose from spacious one or two-bedroom layouts, and enjoy premium amenities like a refreshing pool, inviting sundeck, and on-site business center. Embrace a vibrant community life, complete with planned social activities and nearby walking trails. Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Double Tree Apartments, your ideal oasis nestled in the heart of El Paso, Texas! Our community offers a variety of spacious floor plans, featuring one and two-bedroom apartments designed to meet your lifestyle needs. Each apartment is thoughtfully equipped with modern amenities, including air conditioning, high-speed internet access, and fully-equipped kitchens with dishwashers, microwaves, and refrigerators, ensuring every comfort is at your fingertips.\n\nAt Double Tree, we pride ourselves on a host of community features that cater to your convenience and enjoyment. Dive into our refreshing pool, unwind on the sundeck, or enjoy a delicious meal at our grill and picnic area. For those with a busy schedule, our on-site business center and laundry facilities make life easier. Plus, our planned social activities foster a welcoming community atmosphere.\n\nExperience the luxury of maintenance on-site and a dedicated property manager always ready to assist you. Our smoke-free and pet-friendly community features convenient online services, storage spaces, and even corporate suites. Whether you prefer a walk-up style or a cozy balcony, each apartment offers a delightful combination of comfort and luxury, complete with walk-in closets and stunning views.\n\nEmbrace an active lifestyle with nearby walking and biking trails, or simply relax in the comfortable common areas and built-in bookshelves. Double Tree Apartments is more than just a place to live; it’s a community where you can thrive. \n\nFind your new home today—browse our availability or schedule a tour to visit our vibrant community! ",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-5093-76fb-bc3c-e439e0a04eb9.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of apartment buildings nestled against a mountain landscape.",
    "public_id": "019cfb3f-5093-76fb-bc3c-e439e0a04eb9",
    "storage_key": "property/6767906449165604/019cfb3f-5093-76fb-bc3c-e439e0a04eb9.webp",
    "width": 1600,
    "height": 1067
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "284",
  "property_year_built": "1981",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.94366197183099",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Aggressive breed restrictions apply",
  "property_pet_policy_description": "Pets Welcome - Contact Leasing Office for details",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://doubletreeapartmentselpaso.securecafe.com/onlineleasing/double-tree-apts/floorplans.aspx",
  "property_resident_portal_url": "https://doubletreeapartmentselpaso.securecafe.com/residentservices/double-tree-apts/userlogin.aspx",
  "property_apply_now_url": "https://doubletreeapartmentselpaso.securecafe.com/onlineleasing/double-tree-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-474b-705a-afc6-b0109a1808ba.webp",
  "property_primary_logo_media": {
    "alt_text": "Double Tree logo",
    "public_id": "019cfb3f-474b-705a-afc6-b0109a1808ba",
    "storage_key": "property/6767906449165604/019cfb3f-474b-705a-afc6-b0109a1808ba.webp",
    "width": 300,
    "height": 300
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb40-5662-73e4-ad65-0acd4bba4903.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb40-5662-73e4-ad65-0acd4bba4903",
    "storage_key": "property/6767906449165604/019cfb40-5662-73e4-ad65-0acd4bba4903.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb40-6504-7751-bca6-4672a858da93.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Double Tree logo",
    "public_id": "019cfb40-6504-7751-bca6-4672a858da93",
    "storage_key": "property/6767906449165604/019cfb40-6504-7751-bca6-4672a858da93.webp",
    "width": 300,
    "height": 300
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb89-1df0-715e-a4ab-1ae784060bcc.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Double Tree logo",
    "public_id": "019cfb89-1df0-715e-a4ab-1ae784060bcc",
    "storage_key": "property/6767906449165604/019cfb89-1df0-715e-a4ab-1ae784060bcc.webp",
    "width": 300,
    "height": 300
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#b8b1a8",
  "property_secondary_color": "#5c7375",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 1",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "1",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "491 - 551",
  "property_sqft_min": "491",
  "property_sqft_max": "551",
  "property_price_range": "919 - 969",
  "property_price_min": "919",
  "property_price_max": "969",
  "property_available_units": 3,
  "property_facebook_url": "https://www.facebook.com/thehillsatnorthmesa1/",
  "property_instagram_url": "https://www.instagram.com/p/DIUYz8qTuT_/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ7Qh1P-lX54YR4ZMJmuslKhI",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/doubletree-by-hilton-hotel-el-paso-downtown-el-paso",
  "property_tiktok_url": "https://www.tiktok.com/@doubletreeapartments",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Double Tree Apts.",
  "property_home_romance_title": "Embrace Comfort and Connection in Your Dream Apartment Home",
  "property_home_amenities_blurb": "Welcome to Double Tree Apts. in El Paso, Texas, where comfort meets convenience! Enjoy our spacious one and two-bedroom floor plans, perfect for all lifestyles. With pet-friendly amenities, reliable internet, and onsite laundry, your new home awaits. Experience life at Double Tree today and elevate your living!",
  "property_home_floorplans_blurb": "Welcome to Double Tree Apts., where comfort meets style in the heart of El Paso, Texas. Choose from our thoughtfully designed one and two-bedroom floor plans that cater to your unique lifestyle. Browse our available apartment homes today, and uncover the perfect space to call your own!",
  "property_home_gallery_blurb": "At Double Tree Apts. in El Paso, Texas, envision the perfect blend of comfort and convenience. With spacious one- and two-bedroom floor plans, pet-friendly amenities, and easy access to Fort Bliss, you'll love coming home. Enjoy flexible payment options and super-fast internet—your ideal lifestyle starts here!",
  "property_home_neighborhood_blurb": "Nestled in vibrant El Paso, Double Tree Apts. offers the perfect backdrop for your next adventure. Choose from our stylish one and two-bedroom floor plans and immerse yourself in a community rich with local favorites and unique hotspots. Uncover the charm surrounding your new home today!",
  "property_home_reviews_blurb": "Nestled among the tranquil desert hills of El Paso, Double Tree Apts. offers stunning mountain views and a peaceful atmosphere. Residents cherish the \"quiet of nature\" and convenience of nearby amenities like Planet Fitness and local dining. Experience exceptional living with responsive management and welcoming neighbors—where home truly flourishes.",
  "property_neighborhood_blurb": "At Double Tree Apts. in El Paso, enrich your lifestyle with top-notch educational facilities like Green Elementary, Morehead Middle, and Coronado High School. Nestled in a vibrant neighborhood, our community offers access to enriching experiences and local favorites, creating the ideal environment for growth and connection. See what's around!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Double Tree Apts. in El Paso, Texas, comfort meets convenience. Choose from spacious one- or two-bedroom layouts, each adorned with modern amenities like a refreshing pool, high-speed internet, and inviting outdoor spaces. Enjoy planned social activities and on-site management to elevate your living experience. Welcome home!",
  "property_applynow_blurb": "At Double Tree Apts. in El Paso, Texas, your ideal home awaits! Choose from spacious one or two-bedroom layouts, each crafted for comfort and style. Indulge in amenities like a refreshing pool, business center, and inviting sundeck. Tailor your perfect living experience—apply online and secure your new lifestyle today!",
  "property_contactus_blurb": "At Double Tree Apts. in El Paso, Texas, you’ll find thoughtfully designed one and two-bedroom floor plans, tailored for comfort and style. Whether you’re seeking a cozy retreat or more space, we have the perfect home for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Double Tree Apts. in vibrant El Paso, Texas, you’ll find thoughtfully designed floor plans, including one and two-bedroom options tailored to suit your lifestyle. Uncover the answers to your questions by visiting our FAQs page, where community insights await!",
  "property_floorplans_blurb": "At Double Tree Apts. in vibrant El Paso, Texas, each apartment home is designed for comfort and style. Choose from our spacious one-bedroom or inviting two-bedroom layouts, tailored to fit your lifestyle. Browse our floor plans and envision your future in the perfect space today!",
  "property_gallery_blurb": "At Double Tree Apts. in El Paso, your ideal home awaits! Choose from spacious one or two-bedroom floor plans featuring walk-in closets, modern kitchens, and cozy patios. Relish in our resort-style pool, enjoy social activities, and take advantage of top-notch amenities. Picture yourself living here—your oasis in the heart of Texas!",
  "property_interactivemap_blurb": "At Double Tree Apts. in El Paso, find your perfect home with our versatile one and two-bedroom floor plans. Enjoy amenities like a sparkling pool, walking trails, and social activities. Use our interactive community map to discover available units, pricing, and everything that makes our community unique. ",
  "property_pets_blurb": "At Double Tree Apartments in El Paso, Texas, your furry friends are more than welcome—they’re family! Nestled in a vibrant community, our pet-friendly environment ensures that every paw, tail, and wag finds a cozy home. Reach out to our leasing office for details on our pet policies today!",
  "property_referafriend_blurb": "At Double Tree Apts. in El Paso, Texas, your ideal home awaits. Choose from airy one-bedroom and spacious two-bedroom floor plans designed for comfort and style. Share the joy of living in this vibrant community—refer a friend today and let great friendships flourish right at your doorstep!",
  "property_residentaccess_blurb": "Welcome to Double Tree Apts. in sunny El Paso, Texas, where stylish one and two-bedroom floor plans await. Enjoy modern living that blends comfort with convenience. Access your resident portal to effortlessly pay rent, schedule maintenance, and unlock a vibrant community experience tailored just for you!",
  "property_reviews_blurb": "At Double Tree Apartments in El Paso, tranquility meets convenience. Residents rave about the stunning mountain views and peaceful surroundings, describing it as \"home, in the middle of desert mountain hills.\" With excellent maintenance and a welcoming community, it’s no wonder why so many call Double Tree their home sweet home.",
  "property_created_at": "1753982384082",
  "property_scheduletour_blurb": "At Double Tree Apts. in vibrant El Paso, Texas, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Ready to find your ideal home? Schedule a tour today and hear firsthand from our residents about the exceptional community they cherish!",
  "property_thankyou_blurb": "Thank you for reaching out to Double Tree Apts. in beautiful El Paso, Texas! We look forward to helping you find your perfect space, whether it’s a cozy one-bedroom or a spacious two-bedroom. Stay tuned—our friendly team will be in touch soon to guide you towards your new home!",
  "property_virtualtours_blurb": "At Double Tree Apts. in sunny El Paso, Texas, our thoughtfully designed one and two-bedroom floor plans cater to your unique lifestyle. Experience the charm of our vibrant community—take a virtual tour today and imagine your future home, tailored just for you! ",
  "property_copyright": "2025 All Rights Reserved. Double Tree Apts.",
  "property_seo_title_home": "Double Tree Apts. | Apartments in El Paso, Texas",
  "property_seo_description_home": "Welcome to Double Tree Apts. in El Paso! Choose from versatile floor plans and enjoy fantastic amenities like a pool, business center, and vibrant social activities.",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in El Paso, Texas",
  "property_seo_description_floorplans": "Find your ideal living space at Double Tree Apts. in El Paso! Choose from stylish one and two-bedroom floor plans tailored for your lifestyle.",
  "property_seo_title_amenities": "Amenities | El Paso, Texas Apartments for Rent",
  "property_seo_description_amenities": "Experience life at Double Tree Apts. in El Paso, TX! Enjoy amenities like a pool, furnished units, and scenic walking trails. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in El Paso, Texas",
  "property_seo_description_gallery": "\"Envision life at Double Tree Apts. in El Paso with stunning amenities like a pool, furnished units, and scenic trails. Your next home awaits—explore the gallery!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Double Tree Apts. Apartments",
  "property_seo_description_virtualtours": "Step into comfort at Double Tree Apts. in El Paso! Experience our one & two-bedroom homes through our virtual tour—your new oasis awaits! ",
  "property_seo_title_interactivemap": "Interactive Map | Double Tree Apts. Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Double Tree Apts. in El Paso! Enjoy spacious floor plans, a refreshing pool, and vibrant community spaces. Start your journey today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in El Paso, Texas",
  "property_seo_description_neighborhood": "Uncover the charm of El Paso! At Double Tree Apts., enjoy spacious one and two-bedroom layouts while discovering local favorites just steps away.",
  "property_seo_title_contact": "Contact Us | Double Tree Apts.",
  "property_seo_description_contact": "Connect with Double Tree Apts. in El Paso, TX! Whether you're seeking a cozy one-bedroom or spacious two-bedroom, our leasing team is here to help—all your questions answered!",
  "property_seo_title_faqs": "FAQs | Apartments in El Paso, Texas",
  "property_seo_description_faqs": "Your perfect El Paso retreat awaits at Double Tree Apts! From stunning views to top-notch amenities, find answers to your questions on our FAQs page today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in El Paso, Texas",
  "property_seo_description_reviews": "\"Join the Double Tree Apts. family in El Paso! Enjoy spacious one and two-bedroom homes with amenities like a pool, social events, and easy online services. See our reviews!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in El Paso, Texas",
  "property_seo_description_applynow": "\"Embrace the vibrant lifestyle at Double Tree Apts. in El Paso. Enjoy spacious layouts, modern amenities, and a community designed for comfort—apply online now!\"",
  "property_seo_title_residentaccess": "Resident Access | Double Tree Apts.",
  "property_seo_description_residentaccess": "\"Streamline your life at Double Tree Apts. in El Paso! Log into your resident portal for easy rent payments, maintenance requests, and community updates.\"",
  "property_seo_title_referafriend": "Refer A Friend | Double Tree Apts.",
  "property_seo_description_referafriend": "Refer a friend to Double Tree Apts in El Paso! Share the joy of great living with friends and enjoy exclusive rewards together in our vibrant community!",
  "property_seo_title_scheduletour": "Schedule a Tour | Double Tree Apts.",
  "property_seo_description_scheduletour": "Experience the charm of Double Tree Apts in El Paso. Immerse yourself in our vibrant community—schedule your tour today and envision your new home!",
  "property_seo_title_privacy": "Privacy Policy | Double Tree Apts.",
  "property_seo_description_privacy": "At Double Tree Apts. in El Paso, your privacy matters! Learn how we protect your information with our clear and concise privacy policy. Read it now!",
  "property_seo_title_accessibility": "Website Accessibility | Double Tree Apts.",
  "property_seo_description_accessibility": "\"At Double Tree Apts. in El Paso, we champion accessibility for all. Join us in creating an inclusive community where everyone feels at home.\"",
  "property_seo_title_sitemap": "Sitemap | Double Tree Apts.",
  "property_seo_description_sitemap": "Unveil the layout of Double Tree Apts. in El Paso! Navigate our sitemap for a complete glimpse of your future home sweet home and vibrant community.",
  "property_seo_title_thankyou": "Thank You | Double Tree Apts.",
  "property_seo_description_thankyou": "Thank you for reaching out! A Double Tree Apts. team member will connect soon to help you find your perfect home in El Paso, Texas. Exciting living awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in El Paso, Texas",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865219102",
  "amenities": [
    {
      "id": "ec_5f69dd0e27bd0060500c5dd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127396570",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b60637ff7a11ee614fdbc5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127396571",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8bb9e18935287ed5ba918c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127396572",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17a74b18379f94d8a8acd048",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127396573",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7de5a2334d3197509d5cd86d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127396574",
      "title": "Short Term Lease",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7f8f0025644cd82aecdbeaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127396575",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8fc7ed286a9f5d320c2d71ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127396576",
      "title": "Ideal Location Near Fort Bliss",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_772b686b523302cee4ff956d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127396577",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c9a676bbb598ba770dfa6836",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127396578",
      "title": "Onsite Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fe8c92c1aa574ffcf48a6038",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127396579",
      "title": "Onsite Mailboxes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7d48fb4269005ee3e23f456",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127396580",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e7f87c9bfc2ab602d5189cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127396582",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2bf633dc8a7290ba4377085a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127396583",
      "title": "Spanish Speaking Staff",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c502527253238291a00c5aa2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "128042504",
      "title": "AT&T",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16fe467a764b9e7b86a93576",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127396584",
      "title": "Corporate Apartments Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_19ab21c2c1129fdcee90de96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127398047",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00df231e6ed183030d8ceb76",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127398048",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a44db285c9399f544e2dda34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127398049",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6613335078ffdec38bcc6f10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127398050",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_687fec183075e538c2479e99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127398051",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f91fc1245c250a77268148d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127398052",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6c3ffc4991133e277a6176d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127398053",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_221fbebeb56bbf742d5ba2e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127398054",
      "title": "Front Door Porch*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7fc945c0eac5cc0ff1f181f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127398055",
      "title": "Reliable Cell Reception",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_91c115bd6c644980e4184099",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127398056",
      "title": "Spacious Open Floorplans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_89827bdc198ff74abfdb951d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127398057",
      "title": "Fully Equipped Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3fd03ace891552cbc3e8ad9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127398058",
      "title": "Breakfast Bar*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d27e878cd41d596dcd7943e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127398059",
      "title": "Roommate Friendly Floorplans Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76e76911538d18e51fb4c979",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "yardi",
      "external_id": "127398060",
      "title": "Get connected to super-fast internet powered by AT&T",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_bfe96b4a-d7af-4544-b360-1646f15aca31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92e-2b9c-736e-8e60-ad2d37889c5d.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with landscaping and a red cube sign with Case & Associates logo.",
        "public_id": "019fc92e-2b9c-736e-8e60-ad2d37889c5d",
        "storage_key": "property/6767906449165604/019fc92e-2b9c-736e-8e60-ad2d37889c5d.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "View of the exterior of an apartment building, showcasing its architecture, surrounding landscaping, and a prominent red cube sign displaying the Case & Associates logo.",
      "link": "",
      "alt_text": "Exterior view of apartment building with landscaping and a red cube sign with Case & Associates logo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_61062054-47fe-4301-9f76-4c90fb527a8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92e-26cf-7611-80bb-bf3df7e07b18.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with walkways and landscaping",
        "public_id": "019fc92e-26cf-7611-80bb-bf3df7e07b18",
        "storage_key": "property/6767906449165604/019fc92e-26cf-7611-80bb-bf3df7e07b18.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of an apartment building showcasing its architecture, walkways, and manicured landscaping. A beautiful day with blue skies.",
      "link": "",
      "alt_text": "Apartment building exterior with walkways and landscaping",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0fbdaae3-fc47-4b41-9239-a35615e58c7d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92e-284a-7513-b764-16ec51cc022a.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with walkways and landscaping.",
        "public_id": "019fc92e-284a-7513-b764-16ec51cc022a",
        "storage_key": "property/6767906449165604/019fc92e-284a-7513-b764-16ec51cc022a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "View of the apartment complex's exterior, showcasing the walkways, landscaping, and building architecture.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with walkways and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cd0f8cd7-fc50-43c6-ace9-0aa36f7b905f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92e-22c7-75fd-b7b9-b3a9bbf0f56c.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with courtyard, trees, and gravel landscaping.",
        "public_id": "019fc92e-22c7-75fd-b7b9-b3a9bbf0f56c",
        "storage_key": "property/6767906449165604/019fc92e-22c7-75fd-b7b9-b3a9bbf0f56c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy the beautifully landscaped courtyards with mature trees and serene gravel pathways, offering a peaceful retreat just outside your door.",
      "link": "",
      "alt_text": "Apartment building exterior with courtyard, trees, and gravel landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e0887b2c-a4b7-4a5e-9bd7-8834187fbaea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92e-09b1-7658-955f-118b4bd0531c.webp",
      "image_media": {
        "alt_text": "Aerial view of the apartment complex exterior with mountains in the background.",
        "public_id": "019fc92e-09b1-7658-955f-118b4bd0531c",
        "storage_key": "property/6767906449165604/019fc92e-09b1-7658-955f-118b4bd0531c.webp",
        "width": 2700,
        "height": 1799
      },
      "title": "Community",
      "description": "View of the apartment buildings and surrounding landscape, highlighting the community's setting.",
      "link": "",
      "alt_text": "Aerial view of the apartment complex exterior with mountains in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_28b6df51-b77d-4368-8edc-c72dbf7fb5be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92e-09fd-742d-9b9d-b4bcb22fa026.webp",
      "image_media": {
        "alt_text": "Apartment complex with mountains in the background.",
        "public_id": "019fc92e-09fd-742d-9b9d-b4bcb22fa026",
        "storage_key": "property/6767906449165604/019fc92e-09fd-742d-9b9d-b4bcb22fa026.webp",
        "width": 2700,
        "height": 1799
      },
      "title": "Community",
      "description": "Aerial view of an apartment community nestled against a scenic mountain backdrop. Features multiple buildings, parking areas, and lush landscaping.",
      "link": "",
      "alt_text": "Apartment complex with mountains in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f25f00a5-bd43-4ebc-a5ca-651f4a446055",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92e-0939-7478-8611-4534157f49c4.webp",
      "image_media": {
        "alt_text": "Double Tree Apartment Homes monument sign",
        "public_id": "019fc92e-0939-7478-8611-4534157f49c4",
        "storage_key": "property/6767906449165604/019fc92e-0939-7478-8611-4534157f49c4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to Double Tree Apartment Homes, featuring our prominent monument sign and landscaping. Explore our community and find your perfect home.",
      "link": "",
      "alt_text": "Double Tree Apartment Homes monument sign",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_290a7bd1-ec52-4975-9d89-459cf63cb3a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92e-0a32-71ae-a999-5c3266cdb3dc.webp",
      "image_media": {
        "alt_text": "A paved walkway leads to a grassy area with trees and a fenced swimming pool.",
        "public_id": "019fc92e-0a32-71ae-a999-5c3266cdb3dc",
        "storage_key": "property/6767906449165604/019fc92e-0a32-71ae-a999-5c3266cdb3dc.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling swimming pool, surrounded by lush greenery and mature trees.",
      "link": "",
      "alt_text": "A paved walkway leads to a grassy area with trees and a fenced swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c9866092-4e6d-4668-9ce7-eb62e784266a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92e-0b07-7740-afad-159b0da27e70.webp",
      "image_media": {
        "alt_text": "Covered picnic table with a view of the apartment buildings.",
        "public_id": "019fc92e-0b07-7740-afad-159b0da27e70",
        "storage_key": "property/6767906449165604/019fc92e-0b07-7740-afad-159b0da27e70.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a relaxing outdoor meal at the shaded picnic area, surrounded by lush greenery and scenic views.",
      "link": "",
      "alt_text": "Covered picnic table with a view of the apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9cb82624-965f-4b4a-ac4c-b9d91f9464b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-d133-730d-a410-f2c4a0c211e9.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, white appliances including refrigerator, microwave, stove, and dishwasher.",
        "public_id": "019fc92d-d133-730d-a410-f2c4a0c211e9",
        "storage_key": "property/6767906449165604/019fc92d-d133-730d-a410-f2c4a0c211e9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring ample wood cabinetry, a full suite of white appliances, and convenient counter space.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, white appliances including refrigerator, microwave, stove, and dishwasher.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_86086032-cf39-40ae-b950-a879df7c7e52",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-d146-71b2-b3a6-109ed33d8b8b.webp",
      "image_media": {
        "alt_text": "A cozy bedroom featuring a king-size bed with plush pillows and a soft pink throw, bedside tables with lamps, and a decorative wall accent.",
        "public_id": "019fc92d-d146-71b2-b3a6-109ed33d8b8b",
        "storage_key": "property/6767906449165604/019fc92d-d146-71b2-b3a6-109ed33d8b8b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this inviting bedroom, designed for ultimate relaxation with its plush bedding and stylish decor.",
      "link": "",
      "alt_text": "A cozy bedroom featuring a king-size bed with plush pillows and a soft pink throw, bedside tables with lamps, and a decorative wall accent.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_22fab35d-8987-4caf-b635-5ebdce0985ec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-d0d4-7643-813f-8d8de7e04d58.webp",
      "image_media": {
        "alt_text": "Updated bathroom vanity with sink, toilet, and bathtub with shower curtain.",
        "public_id": "019fc92d-d0d4-7643-813f-8d8de7e04d58",
        "storage_key": "property/6767906449165604/019fc92d-d0d4-7643-813f-8d8de7e04d58.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Renovated bathroom featuring a modern vanity with a sink, a toilet, and a bathtub with a clean shower curtain for a fresh look.",
      "link": "",
      "alt_text": "Updated bathroom vanity with sink, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0609ce02-3efb-46ba-997e-af9432a86f7b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-cfbf-74cd-95c8-f41c92690738.webp",
      "image_media": {
        "alt_text": "Updated kitchen with wood cabinets, stainless steel sink, dishwasher, and refrigerator.",
        "public_id": "019fc92d-cfbf-74cd-95c8-f41c92690738",
        "storage_key": "property/6767906449165604/019fc92d-cfbf-74cd-95c8-f41c92690738.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this updated kitchen featuring ample wood cabinetry, a double basin sink, and a dishwasher. Includes a refrigerator and stove.",
      "link": "",
      "alt_text": "Updated kitchen with wood cabinets, stainless steel sink, dishwasher, and refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_93835ca2-733a-4b14-a673-49b983e5bf13",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-cea7-71da-88e7-dfc427d5bff5.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances and wooden cabinets.",
        "public_id": "019fc92d-cea7-71da-88e7-dfc427d5bff5",
        "storage_key": "property/6767906449165604/019fc92d-cea7-71da-88e7-dfc427d5bff5.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring white appliances, ample cabinet space, and a neutral color palette.",
      "link": "",
      "alt_text": "Kitchen with white appliances and wooden cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9c7f86c2-8ca5-43fb-a291-1037ac6edbd8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-bc82-71c7-b86f-79b2c67bfd1b.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white walls and shelving",
        "public_id": "019fc92d-bc82-71c7-b86f-79b2c67bfd1b",
        "storage_key": "property/6767906449165604/019fc92d-bc82-71c7-b86f-79b2c67bfd1b.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving and neutral carpeting, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with white walls and shelving",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f72fa725-0597-4295-99e7-dfb74ff6dc9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-c266-766a-8dfa-5e3a2decbbfd.webp",
      "image_media": {
        "alt_text": "Dining area with a round table, two chairs, and a modern art piece on the wall.",
        "public_id": "019fc92d-c266-766a-8dfa-5e3a2decbbfd",
        "storage_key": "property/6767906449165604/019fc92d-c266-766a-8dfa-5e3a2decbbfd.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A stylish dining nook featuring a round table set for two, complete with comfortable seating and modern wall art, creating an inviting atmosphere.",
      "link": "",
      "alt_text": "Dining area with a round table, two chairs, and a modern art piece on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cc8f0bdd-ca32-44ac-a2d7-4cdae2b0410a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-c221-753e-90f9-bf6d775b85bc.webp",
      "image_media": {
        "alt_text": "Living room with a gray sectional sofa, coffee table, and TV stand with a large television.",
        "public_id": "019fc92d-c221-753e-90f9-bf6d775b85bc",
        "storage_key": "property/6767906449165604/019fc92d-c221-753e-90f9-bf6d775b85bc.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax and unwind in this comfortable living room, featuring a plush sectional sofa, a spacious coffee table, and a modern entertainment center with a large TV.",
      "link": "",
      "alt_text": "Living room with a gray sectional sofa, coffee table, and TV stand with a large television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c061d3ac-84f2-4bcc-8888-8c945cd586ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-b579-76ce-9fce-00352994a0e8.webp",
      "image_media": {
        "alt_text": "Bedroom with a pink bed, white bedding, and decorative pillows. A ceiling fan is visible overhead.",
        "public_id": "019fc92d-b579-76ce-9fce-00352994a0e8",
        "storage_key": "property/6767906449165604/019fc92d-b579-76ce-9fce-00352994a0e8.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a plush pink bed, soft white bedding, and stylish decorative pillows. Overhead, a classic ceiling fan circulates air.",
      "link": "",
      "alt_text": "Bedroom with a pink bed, white bedding, and decorative pillows. A ceiling fan is visible overhead.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_175037c5-e12c-4bc7-aa47-c2159f2841c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-bcb5-74dd-88aa-f98836687fc6.webp",
      "image_media": {
        "alt_text": "Modern living room with a gray sectional sofa, coffee table, bookshelf, and dining area.",
        "public_id": "019fc92d-bcb5-74dd-88aa-f98836687fc6",
        "storage_key": "property/6767906449165604/019fc92d-bcb5-74dd-88aa-f98836687fc6.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Spacious and well-lit living area featuring a comfortable gray sectional sofa, a wooden coffee table with decorative items, and ample storage on a built-in bookshelf. The adjacent dining area offers a cozy spot for meals.",
      "link": "",
      "alt_text": "Modern living room with a gray sectional sofa, coffee table, bookshelf, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_347c1e2f-28f0-47f4-9d86-d6b999a2d926",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-b4a7-7211-a427-2c27fc68f7b0.webp",
      "image_media": {
        "alt_text": "Exterior door with a light blue door, brass kick plate, and a grey wooden fence on the left.",
        "public_id": "019fc92d-b4a7-7211-a427-2c27fc68f7b0",
        "storage_key": "property/6767906449165604/019fc92d-b4a7-7211-a427-2c27fc68f7b0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Exterior view of a light blue apartment door, accented by a brass kick plate and a grey wooden fence.",
      "link": "",
      "alt_text": "Exterior door with a light blue door, brass kick plate, and a grey wooden fence on the left.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4b0b9318-581f-4d2f-9e50-c033ee7f141d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-bca7-72af-b347-911760106ac9.webp",
      "image_media": {
        "alt_text": "Bathroom with a vanity, toilet, and bathtub with a pink shower curtain.",
        "public_id": "019fc92d-bca7-72af-b347-911760106ac9",
        "storage_key": "property/6767906449165604/019fc92d-bca7-72af-b347-911760106ac9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Refresh and unwind in this well-appointed bathroom, featuring a spacious vanity, a convenient toilet, and a relaxing bathtub with a stylish shower curtain.",
      "link": "",
      "alt_text": "Bathroom with a vanity, toilet, and bathtub with a pink shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6fa5d8f4-3df0-498f-9980-7eddf91fb3e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-bca1-73a9-826f-cabbcabaaded.webp",
      "image_media": {
        "alt_text": "Living room with a TV, entertainment center, bookshelf, coffee table, and sofa.",
        "public_id": "019fc92d-bca1-73a9-826f-cabbcabaaded",
        "storage_key": "property/6767906449165604/019fc92d-bca1-73a9-826f-cabbcabaaded.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A comfortable living room featuring a large TV, ample storage, and a coffee table, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Living room with a TV, entertainment center, bookshelf, coffee table, and sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b12adf6d-677b-4eaa-becc-b4891c99a491",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-ad5c-7218-ac46-4f88208e3278.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, dresser, and ceiling fan.",
        "public_id": "019fc92d-ad5c-7218-ac46-4f88208e3278",
        "storage_key": "property/6767906449165604/019fc92d-ad5c-7218-ac46-4f88208e3278.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush queen-size bed, ample storage with a spacious dresser, and a cooling ceiling fan.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9be97fa7-69b4-41e0-9547-af9346aea4e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-ad66-721e-b43d-80b5b3fff92e.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed and a view of the living room.",
        "public_id": "019fc92d-ad66-721e-b43d-80b5b3fff92e",
        "storage_key": "property/6767906449165604/019fc92d-ad66-721e-b43d-80b5b3fff92e.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "This bedroom features a cozy queen-size bed, a bedside table, and a view into the living room. Perfect for relaxation.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed and a view of the living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5946cd84-8fdb-4b44-abb4-a722b830a3b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-a841-75ba-b57b-91dc0877302a.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, white appliances, and a double sink.",
        "public_id": "019fc92d-a841-75ba-b57b-91dc0877302a",
        "storage_key": "property/6767906449165604/019fc92d-a841-75ba-b57b-91dc0877302a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A charming kitchen featuring warm wood cabinetry, a convenient double sink, and bright white appliances, perfect for everyday living.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, white appliances, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b4a59ed1-d72b-4d21-ac0f-4582fe1b08c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-a4e1-74f1-9ef0-ee45ac4270db.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white appliances, wooden cabinets, and granite countertops.",
        "public_id": "019fc92d-a4e1-74f1-9ef0-ee45ac4270db",
        "storage_key": "property/6767906449165604/019fc92d-a4e1-74f1-9ef0-ee45ac4270db.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A bright and functional kitchen featuring stainless steel appliances, ample cabinet space, and granite countertops, perfect for everyday cooking.",
      "link": "",
      "alt_text": "Modern kitchen with white appliances, wooden cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bda8ba35-a4b6-4140-b6c4-d1b1e0f4977c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-95c5-7670-9936-1e73e8ae4980.webp",
      "image_media": {
        "alt_text": "Exterior building view with stairs and walkway",
        "public_id": "019fc92d-95c5-7670-9936-1e73e8ae4980",
        "storage_key": "property/6767906449165604/019fc92d-95c5-7670-9936-1e73e8ae4980.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings with stairs leading to the upper levels. The property features a stone accent wall and landscaping.",
      "link": "",
      "alt_text": "Exterior building view with stairs and walkway",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a5323be3-cf06-48cf-8bcc-5fc949f46d2b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-9621-72bf-b069-a8da21b7c569.webp",
      "image_media": {
        "alt_text": "Dining area with a small round table, two chairs, and wall decor.",
        "public_id": "019fc92d-9621-72bf-b069-a8da21b7c569",
        "storage_key": "property/6767906449165604/019fc92d-9621-72bf-b069-a8da21b7c569.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "A cozy dining area featuring a marble-top tulip table, two upholstered chairs, and decorative wall art, perfect for intimate meals.",
      "link": "",
      "alt_text": "Dining area with a small round table, two chairs, and wall decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_93bd6711-e48a-4d84-9e57-df45256f683d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-8d37-70da-b19f-e1b03a1dc85a.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in an apartment with modern decor, including a sectional sofa, coffee table, and dining area.",
        "public_id": "019fc92d-8d37-70da-b19f-e1b03a1dc85a",
        "storage_key": "property/6767906449165604/019fc92d-8d37-70da-b19f-e1b03a1dc85a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this open-concept apartment, featuring a stylish living room seamlessly connected to a functional kitchen and a cozy dining space.",
      "link": "",
      "alt_text": "Living room and kitchen area in an apartment with modern decor, including a sectional sofa, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_41779277-6f15-4ddf-ab8d-f92e07c896ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-8bcb-74c8-9dae-39bec4a1b9a0.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with stairs and walkway",
        "public_id": "019fc92d-8bcb-74c8-9dae-39bec4a1b9a0",
        "storage_key": "property/6767906449165604/019fc92d-8bcb-74c8-9dae-39bec4a1b9a0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Exterior view of an apartment building showcasing its architectural design, including stairs and walkways, set against a backdrop of trees and a blue sky.",
      "link": "",
      "alt_text": "Exterior of apartment building with stairs and walkway",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b99867d1-b03b-4cde-9521-aa14232f4463",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-9e61-7098-b256-8cab0ef3533a.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white appliances, and a double sink.",
        "public_id": "019fc92d-9e61-7098-b256-8cab0ef3533a",
        "storage_key": "property/6767906449165604/019fc92d-9e61-7098-b256-8cab0ef3533a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this well-equipped kitchen featuring ample cabinet space, a dishwasher, a refrigerator, and a stove with a microwave above.",
      "link": "",
      "alt_text": "Kitchen with wooden cabinets, white appliances, and a double sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d27bdcf9-0455-4af0-bcaf-f4bba7f9291f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-8cc1-7783-9691-865fcfa1df74.webp",
      "image_media": {
        "alt_text": "Kitchen with dining area, featuring wooden cabinets, white appliances, and a small table with two chairs.",
        "public_id": "019fc92d-8cc1-7783-9691-865fcfa1df74",
        "storage_key": "property/6767906449165604/019fc92d-8cc1-7783-9691-865fcfa1df74.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Charming kitchen and dining space with warm wooden cabinets and a cozy breakfast nook, perfect for intimate meals.",
      "link": "",
      "alt_text": "Kitchen with dining area, featuring wooden cabinets, white appliances, and a small table with two chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a98bbcaf-9c06-495e-8823-ac549ba9e5a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-8c04-75cc-bb20-76a0e64275b4.webp",
      "image_media": {
        "alt_text": "Living room with sectional sofa, coffee table, floor lamp, and wicker chair.",
        "public_id": "019fc92d-8c04-75cc-bb20-76a0e64275b4",
        "storage_key": "property/6767906449165604/019fc92d-8c04-75cc-bb20-76a0e64275b4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a sectional sofa, a rustic coffee table, and a decorative floor lamp. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with sectional sofa, coffee table, floor lamp, and wicker chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_60e2f3d8-6fd2-444a-8396-7f9fa245004a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92d-8a21-70bb-bc59-d27ce9e75b2a.webp",
      "image_media": {
        "alt_text": "Comfortable bedroom with a king-size bed, plush pillows, and a ceiling fan.",
        "public_id": "019fc92d-8a21-70bb-bc59-d27ce9e75b2a",
        "storage_key": "property/6767906449165604/019fc92d-8a21-70bb-bc59-d27ce9e75b2a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in this cozy bedroom featuring a spacious king-size bed, adorned with soft pillows and a luxurious throw blanket. A ceiling fan ensures comfort.",
      "link": "",
      "alt_text": "Comfortable bedroom with a king-size bed, plush pillows, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_69cf5f3f-236d-4832-bccc-26d292b3c42e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92c-fa98-75bc-a15e-ca6e871642b4.webp",
      "image_media": {
        "alt_text": "Exterior building entrance with teal doors, welcome mat, and bench.",
        "public_id": "019fc92c-fa98-75bc-a15e-ca6e871642b4",
        "storage_key": "property/6767906449165604/019fc92c-fa98-75bc-a15e-ca6e871642b4.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "The welcoming entrance to the apartment building features teal double doors, a comfortable bench with striped pillows, and a decorative planter.",
      "link": "",
      "alt_text": "Exterior building entrance with teal doors, welcome mat, and bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d00eba5b-213f-411f-aa82-cd4febd1ef4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92c-f37f-70e7-9395-149b19cfc289.webp",
      "image_media": {
        "alt_text": "Mailroom with rows of mailboxes.",
        "public_id": "019fc92c-f37f-70e7-9395-149b19cfc289",
        "storage_key": "property/6767906449165604/019fc92c-f37f-70e7-9395-149b19cfc289.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Secure mailroom with multiple rows of mailboxes for residents.",
      "link": "",
      "alt_text": "Mailroom with rows of mailboxes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b4067915-3a32-4c35-9801-a6cf09cd1131",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92c-d22b-7051-99a9-b27f56fa5e01.webp",
      "image_media": {
        "alt_text": "Bright blue outdoor swimming pool with lounge chairs and trees surrounding it.",
        "public_id": "019fc92c-d22b-7051-99a9-b27f56fa5e01",
        "storage_key": "property/6767906449165604/019fc92c-d22b-7051-99a9-b27f56fa5e01.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, surrounded by lush greenery and comfortable lounge chairs.",
      "link": "",
      "alt_text": "Bright blue outdoor swimming pool with lounge chairs and trees surrounding it.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aa7c30c5-336e-44a2-a059-0121eb5b9b81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92c-c8b1-7720-9841-7623c3c733a7.webp",
      "image_media": {
        "alt_text": "An outdoor swimming pool with lounge chairs and surrounding trees.",
        "public_id": "019fc92c-c8b1-7720-9841-7623c3c733a7",
        "storage_key": "property/6767906449165604/019fc92c-c8b1-7720-9841-7623c3c733a7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush trees and ample seating for relaxation.",
      "link": "",
      "alt_text": "An outdoor swimming pool with lounge chairs and surrounding trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_db5b09ab-ada5-4d85-8442-37d4d64bd140",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92c-d28b-73a4-a06f-71788c7d7ecd.webp",
      "image_media": {
        "alt_text": "Living room with a large sectional sofa, coffee table, and entertainment center with a TV.",
        "public_id": "019fc92c-d28b-73a4-a06f-71788c7d7ecd",
        "storage_key": "property/6767906449165604/019fc92c-d28b-73a4-a06f-71788c7d7ecd.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in this spacious living room, perfect for entertaining or unwinding after a long day. Features a comfortable sectional, stylish coffee table, and modern entertainment center.",
      "link": "",
      "alt_text": "Living room with a large sectional sofa, coffee table, and entertainment center with a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d6a844c-3ade-4ea5-a56c-52d46a76d1ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92c-c655-735b-be89-fd829892c760.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with lounge chairs and tables under a pergola near a stone wall.",
        "public_id": "019fc92c-c655-735b-be89-fd829892c760",
        "storage_key": "property/6767906449165604/019fc92c-c655-735b-be89-fd829892c760.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our outdoor seating area, complete with comfortable lounge chairs and shaded tables. Perfect for enjoying a sunny day or a cool evening.",
      "link": "",
      "alt_text": "Outdoor seating area with lounge chairs and tables under a pergola near a stone wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_460ff6e2-e52b-47b2-b561-6db946bc7710",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92c-c7f2-712f-8888-19cc5e06a597.webp",
      "image_media": {
        "alt_text": "Swimming pool area with lounge chairs and apartment buildings in the background.",
        "public_id": "019fc92c-c7f2-712f-8888-19cc5e06a597",
        "storage_key": "property/6767906449165604/019fc92c-c7f2-712f-8888-19cc5e06a597.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool, complete with comfortable lounge chairs and a serene atmosphere. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Swimming pool area with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d4e8a650-0f3c-411a-b64c-6a2e93d53e63",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92c-d6b3-75da-ae27-3c0faad9d657.webp",
      "image_media": {
        "alt_text": "Laundry room with rows of washers and dryers.",
        "public_id": "019fc92c-d6b3-75da-ae27-3c0faad9d657",
        "storage_key": "property/6767906449165604/019fc92c-d6b3-75da-ae27-3c0faad9d657.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with multiple washers and dryers for resident use.",
      "link": "",
      "alt_text": "Laundry room with rows of washers and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ab54f61e-934d-44f1-835f-a6c13b7b9635",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019fc92c-c551-71aa-aec0-7fd452e870b3.webp",
      "image_media": {
        "alt_text": "Row of commercial washers and dryers in a laundry room.",
        "public_id": "019fc92c-c551-71aa-aec0-7fd452e870b3",
        "storage_key": "property/6767906449165604/019fc92c-c551-71aa-aec0-7fd452e870b3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities with multiple washers and dryers available for residents.",
      "link": "",
      "alt_text": "Row of commercial washers and dryers in a laundry room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_620a6578-c297-40ab-82c8-82f3cd4d9a4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Topgolf El Paso",
      "poi_type": "Restaurants",
      "poi_address": "365 Vin Rambla Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun golfing experience with a variety of games suitable for all skill levels. They highlight the lively atmosphere, perfect for outings with friends and family, and the availability of heat in every bay. They also like the friendly and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-00c9-71af-97b7-9c7082e7021d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-00c9-71af-97b7-9c7082e7021d",
        "storage_key": "property/6767906449165604/019d2709-00c9-71af-97b7-9c7082e7021d.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://topgolf.com/us/el-paso/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10477886874640848166&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-el-paso",
      "poi_latitude": "31.8107961",
      "poi_longitude": "-106.5250411",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-845-9028",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-33da-731b-9369-9f6ddf6d7616.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-33da-731b-9369-9f6ddf6d7616",
        "storage_key": "property/6767906449165604/019d2709-33da-731b-9369-9f6ddf6d7616.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLxkkkflX54YRJhWyJ5nuaJE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ba9f1242-b790-4588-8b67-4acd6b2867ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "L & J Cafe",
      "poi_type": "Restaurants",
      "poi_address": "3622 E Missouri Ave, El Paso, TX 79903, USA",
      "poi_short_description": "A local landmark dating back to 1927, this family-run eatery serves regional Mexican dishes & beers.",
      "poi_long_description": "People say this Mexican restaurant serves delicious green chicken enchiladas, chile rellenos, and a combination plate. They highlight the affordable prices and fun, lively atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-0089-7159-b93c-2cd204988532.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0089-7159-b93c-2cd204988532",
        "storage_key": "property/6767906449165604/019d2709-0089-7159-b93c-2cd204988532.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://ljcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=253529114313290020&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "l--j-cafe",
      "poi_latitude": "31.7795154",
      "poi_longitude": "-106.4497953",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 915-566-8418",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-33da-731b-9369-9f6ddf6d7616.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-33da-731b-9369-9f6ddf6d7616",
        "storage_key": "property/6767906449165604/019d2709-33da-731b-9369-9f6ddf6d7616.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy58M-oRZ54YRJPHc3mK3hAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_f8a96cd5-465a-485c-aa30-1386b325b15b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Taconeta",
      "poi_type": "Restaurants",
      "poi_address": "311 Montana Ave A-1, El Paso, TX 79902, USA",
      "poi_short_description": "Classic Mexican plates doled out in an unpretentious restaurant with an airy dining room.",
      "poi_long_description": "People say this taco restaurant serves delicious brisket, chicken, shrimp, and mushroom tacos, as well as tasty elote and refreshing cucumber lime drinks. They highlight the fresh ingredients, flavorful combinations, and the fun, laid-back vibe. They also like the quick and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-0039-738a-ab44-cd52c68bc968.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0039-738a-ab44-cd52c68bc968",
        "storage_key": "property/6767906449165604/019d2709-0039-738a-ab44-cd52c68bc968.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.toasttab.com/taconeta",
      "poi_directions_map_url": "https://maps.google.com/?cid=10960950357964817459&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "taconeta",
      "poi_latitude": "31.7648439",
      "poi_longitude": "-106.4904197",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-303-8038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-33da-731b-9369-9f6ddf6d7616.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-33da-731b-9369-9f6ddf6d7616",
        "storage_key": "property/6767906449165604/019d2709-33da-731b-9369-9f6ddf6d7616.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs_NrqhpZ54YRMwQv50YeHZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "custom_d98ca3dd-ace4-44c3-af2d-8c015de86cfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Salt + Honey Bakery Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1125 Texas Ave, El Paso, TX 79901, USA",
      "poi_short_description": "Cool, brick-lined locale with a creative cafe menu, cold-pressed juices & locally roasted coffee.",
      "poi_long_description": "People say this breakfast restaurant serves delicious chicken and waffles, baklava pancakes, and a variety of coffee drinks, including the Salt and Honey Latte. They also highlight the relaxing and inviting atmosphere, and the friendly and attentive service.\n\nOther reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-010b-74ef-b66e-b109b120e2e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-010b-74ef-b66e-b109b120e2e5",
        "storage_key": "property/6767906449165604/019d2709-010b-74ef-b66e-b109b120e2e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.saltandhoneyep.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4866789244147418890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "salt--honey-bakery-cafe",
      "poi_latitude": "31.7648676",
      "poi_longitude": "-106.4783652",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 915-313-4907",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-33da-731b-9369-9f6ddf6d7616.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-33da-731b-9369-9f6ddf6d7616",
        "storage_key": "property/6767906449165604/019d2709-33da-731b-9369-9f6ddf6d7616.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG7y4m5dZ54YRCkcZPghPikM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_abcd6856-dd28-48d3-ae00-96a46771b2d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "5010 N Desert Blvd, El Paso, TX 79912, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and chicken, and the rolls with cinnamon butter are a highlight. They highlight the generous portions, good value, and lively, country-themed atmosphere. They also like the attentive service and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-0500-73a8-9f65-e8428c510d18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0500-73a8-9f65-e8428c510d18",
        "storage_key": "property/6767906449165604/019d2709-0500-73a8-9f65-e8428c510d18.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/texas/el-paso-n-desert-blvd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=2594805389550251164&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "31.8404434",
      "poi_longitude": "-106.5685133",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-832-0333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-33da-731b-9369-9f6ddf6d7616.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-33da-731b-9369-9f6ddf6d7616",
        "storage_key": "property/6767906449165604/019d2709-33da-731b-9369-9f6ddf6d7616.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ684Xlln43YYRnGxpAcGZAiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_4ad9d5c9-7274-4118-9738-85d6ca6975b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "100 Pitt St, El Paso, TX 79912, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh, healthy, and specialty foods, including organic produce, meats, seafood, and baked goods. They highlight the convenient Amazon return service, the tap room with a selection of beers and wines, and the outdoor deck. They also like the clean and well-stocked store, and the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-0560-77bb-bbca-cd1ee557c396.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0560-77bb-bbca-cd1ee557c396",
        "storage_key": "property/6767906449165604/019d2709-0560-77bb-bbca-cd1ee557c396.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/elpaso?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=5575333113701639611&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "31.8340462",
      "poi_longitude": "-106.5480013",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-236-1420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-33bc-702e-b6e6-5ee551e7d5f1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-33bc-702e-b6e6-5ee551e7d5f1",
        "storage_key": "property/6767906449165604/019d2709-33bc-702e-b6e6-5ee551e7d5f1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj13blm_43YYRu6Wocu2PX00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d1ce4087-2db8-41da-80c1-5f5ec38e4e5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "The Shoppes at Solana",
      "poi_type": "Shopping & Retail",
      "poi_address": "750 Sunland Park Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Prominent indoor shopping center with 100+ stores on 2 levels, plus chain restaurants & a theater.",
      "poi_long_description": "People say this shopping center offers a variety of stores, including kid-friendly options and unique businesses. They also highlight the spacious layout, clean environment, and fun activities, such as a petting zoo and fireworks displays.\n\nOther reviews mention the mall can be empty.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-071f-7432-b9aa-b4a0bb62192b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-071f-7432-b9aa-b4a0bb62192b",
        "storage_key": "property/6767906449165604/019d2709-071f-7432-b9aa-b4a0bb62192b.webp",
        "width": 1280,
        "height": 686
      },
      "poi_business_url": "http://theshoppesatsolana.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2107962478139008266&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-shoppes-at-solana",
      "poi_latitude": "31.8144216",
      "poi_longitude": "-106.5440443",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-833-5596",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-33c1-731c-a0d9-341c07317854.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-33c1-731c-a0d9-341c07317854",
        "storage_key": "property/6767906449165604/019d2709-33c1-731c-a0d9-341c07317854.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJoWrRgA_43YYRCuVTlbT8QB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_7f0f5503-75f1-4d34-9dde-04a338c3c970",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "7545 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store offers a wide variety of products, including tools, lumber, and electrical parts. They also highlight the helpful and friendly staff, and the convenient hours.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-061d-768b-b183-fc61e07857ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-061d-768b-b183-fc61e07857ac",
        "storage_key": "property/6767906449165604/019d2709-061d-768b-b183-fc61e07857ac.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.homedepot.com/l/West-El-Paso/TX/El-Paso/79912/523?emt=MSEN?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7694583817001495963&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "31.8358838",
      "poi_longitude": "-106.5641494",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 915-585-2319",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-33c1-731c-a0d9-341c07317854.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-33c1-731c-a0d9-341c07317854",
        "storage_key": "property/6767906449165604/019d2709-33c1-731c-a0d9-341c07317854.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8zsx0lv43YYRm-3XwjanyGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_3fcc5430-00c5-433b-b6be-5dce584e71ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "430 Redd Rd, El Paso, TX 79912, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a wide variety of supplies for projects. They also highlight the helpful and attentive service provided by some staff.\n\nOther reviews mention the delivery service can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-0978-706b-a339-548ec119d1b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0978-706b-a339-548ec119d1b8",
        "storage_key": "property/6767906449165604/019d2709-0978-706b-a339-548ec119d1b8.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TX-El-Paso/1152?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1152-_-na-_-0-_-0&y_source=1_MTE4NDM4Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5332424068888550467&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "31.86153",
      "poi_longitude": "-106.57317",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-581-4401",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-33c1-731c-a0d9-341c07317854.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-33c1-731c-a0d9-341c07317854",
        "storage_key": "property/6767906449165604/019d2709-33c1-731c-a0d9-341c07317854.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJUewuiOb43YYRQ1zYMXCTAEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_16e0345d-a2df-4649-838c-69d69a80e8b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Fort Bliss - Exchange",
      "poi_type": "Shopping & Retail",
      "poi_address": "1611 Haan Rd, Fort Bliss, TX 79906, USA",
      "poi_short_description": "Shopping mall at Freedom Crossing at Fort Bliss with a food court and tax-free bonus savings for military members and veterans.",
      "poi_long_description": "People say this shopping center offers a huge selection of products and services, and a food court with fantastic choices. They highlight the clean and well-organized layout, and the great prices. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-0adc-741a-945b-d623a4b9a42b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0adc-741a-945b-d623a4b9a42b",
        "storage_key": "property/6767906449165604/019d2709-0adc-741a-945b-d623a4b9a42b.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.shopmyexchange.com/exchange-stores/United%20States/TX/Ft.%20Bliss/Ft-Bliss--1011801",
      "poi_directions_map_url": "https://maps.google.com/?cid=10221724360285077533&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fort-bliss---exchange",
      "poi_latitude": "31.8180883",
      "poi_longitude": "-106.4295632",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 915-562-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-33c1-731c-a0d9-341c07317854.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-33c1-731c-a0d9-341c07317854",
        "storage_key": "property/6767906449165604/019d2709-33c1-731c-a0d9-341c07317854.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ83LPBZ9Z54YRHcC_Dibc2o0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_9ddc240e-85bb-4fac-bcc1-bf72d1e6c61c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "University of Texas at El Paso",
      "poi_type": "Education",
      "poi_address": "500 W University Ave, El Paso, TX 79968, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-0b02-74eb-88fe-bc20cb4045f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0b02-74eb-88fe-bc20cb4045f3",
        "storage_key": "property/6767906449165604/019d2709-0b02-74eb-88fe-bc20cb4045f3.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.utep.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15130569928881990844&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-texas-at-el-paso",
      "poi_latitude": "31.7726162",
      "poi_longitude": "-106.5059564",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-747-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-33e2-737e-a275-0555954f25e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-33e2-737e-a275-0555954f25e5",
        "storage_key": "property/6767906449165604/019d2709-33e2-737e-a275-0555954f25e5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ12KA7lpY54YRvOw3ZC-V-tE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ed35f927-1e3f-438f-ae31-53c8f94434b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Texas Tech University Health Sciences Center El Paso",
      "poi_type": "Education",
      "poi_address": "5001 El Paso Dr, El Paso, TX 79905, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-0c7e-77e7-8d90-20949bb364a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0c7e-77e7-8d90-20949bb364a2",
        "storage_key": "property/6767906449165604/019d2709-0c7e-77e7-8d90-20949bb364a2.webp",
        "width": 1280,
        "height": 631
      },
      "poi_business_url": "http://www.elpaso.ttuhsc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3406232647974928991&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-tech-university-health-sciences-center-el-paso",
      "poi_latitude": "31.7741906",
      "poi_longitude": "-106.4322838",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 915-215-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-33e2-737e-a275-0555954f25e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-33e2-737e-a275-0555954f25e5",
        "storage_key": "property/6767906449165604/019d2709-33e2-737e-a275-0555954f25e5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3_KUadNb54YRX0Li3IteRS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_abd09870-7dc7-4618-8e42-2edcb65068ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "University Library",
      "poi_type": "Education",
      "poi_address": "1900 Wiggins Rd, El Paso, TX 79968, USA",
      "poi_short_description": "University library with free admission and study space, plus a coffee shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-0ed2-7557-a67e-0974ae559074.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0ed2-7557-a67e-0974ae559074",
        "storage_key": "property/6767906449165604/019d2709-0ed2-7557-a67e-0974ae559074.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utep.edu/library",
      "poi_directions_map_url": "https://maps.google.com/?cid=16419899299576992938&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-library",
      "poi_latitude": "31.7673517",
      "poi_longitude": "-106.5047201",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-747-5672",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3798-730b-a09c-c08b9a98ae3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3798-730b-a09c-c08b9a98ae3e",
        "storage_key": "property/6767906449165604/019d2709-3798-730b-a09c-c08b9a98ae3e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc7gl1lhY54YRqtT4pmoz3-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_502f1646-7c1e-4845-86df-173897951eee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Sun Bowl",
      "poi_type": "Entertainment",
      "poi_address": "2701 Sun Bowl Dr, El Paso, TX 79902, USA",
      "poi_short_description": "University of Texas El Paso Miners' 51,500-seat outdoor football arena & site of the Sun Bowl game.",
      "poi_long_description": "People say this stadium offers a variety of events, including concerts, football games, and Monster Jam shows. They highlight the beautiful setting carved into a mountain overlooking the city, and the smooth traffic flow and well-maintained facilities. They also like the helpful staff and the ample parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-0ff5-70fd-a921-9fb68d61b833.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0ff5-70fd-a921-9fb68d61b833",
        "storage_key": "property/6767906449165604/019d2709-0ff5-70fd-a921-9fb68d61b833.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.utepspecialevents.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12740333998005602376&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sun-bowl",
      "poi_latitude": "31.7733442",
      "poi_longitude": "-106.5079256",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-381f-7673-8ee8-4a6a8256f6ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-381f-7673-8ee8-4a6a8256f6ed",
        "storage_key": "property/6767906449165604/019d2709-381f-7673-8ee8-4a6a8256f6ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ3x541xY54YRSMj0HkXCzrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_dfecfb9f-1dc8-4cf2-8d90-0cd55f190b80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Don Haskins Center",
      "poi_type": "Entertainment",
      "poi_address": "151 Glory Rd, El Paso, TX 79902, USA",
      "poi_short_description": "Arena hosting big concerts and other events with food, drink, and free parking.",
      "poi_long_description": "People say this arena is a great place to attend graduations, with many mentioning its comfortable seating and well-organized events. They also highlight the efficient air conditioning, which provides a cool respite from the hot El Paso weather.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-0ffa-76e7-99c7-73843317136f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0ffa-76e7-99c7-73843317136f",
        "storage_key": "property/6767906449165604/019d2709-0ffa-76e7-99c7-73843317136f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utepspecialevents.com/venues/don_haskins_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=11992951360778632993&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "don-haskins-center",
      "poi_latitude": "31.7776195",
      "poi_longitude": "-106.5056719",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-747-5481",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3798-730b-a09c-bc75d482095c",
        "storage_key": "property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ46MilERY54YRIX-_o7iFb6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_6682c95c-3fa1-4e34-ac7c-23928942e302",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "El Paso Zoo and Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "Train Station, 4001 E Paisano Dr, El Paso, TX 79905, USA",
      "poi_short_description": "220 African, American & Asian species residing in facsimiles of natural habitats in a 35-acre park.",
      "poi_long_description": "Visitors say this zoo offers a wide variety of animals, including penguins, sea lions, giraffes, and wolves, with fun activities like a splash pad and playground for kids. They also highlight the friendly staff, clean facilities, and educational exhibits.\n\nSome reviews mention many exhibits can be closed for renovations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-12da-76b9-8c4f-43b92fe82dc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-12da-76b9-8c4f-43b92fe82dc1",
        "storage_key": "property/6767906449165604/019d2709-12da-76b9-8c4f-43b92fe82dc1.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://www.elpasozoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9154948632860338008&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-zoo-and-botanical-gardens",
      "poi_latitude": "31.7690489",
      "poi_longitude": "-106.4448897",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 915-212-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3798-730b-a09c-bc75d482095c",
        "storage_key": "property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7ASQX5Z54YRWKeWzkbpDH8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_9d6c5b9b-10a2-4ed8-8bdd-b1132f1a5555",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Estadio Olímpico Benito Juárez",
      "poi_type": "Entertainment",
      "poi_address": "Av. Heroico Colegio Militar 51, Chamizal, 32300 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "People say this stadium offers a great atmosphere and good snacks. They highlight the stadium is well-organized, safe, and comfortable, with good views of the game. They also like the friendly and passionate environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-1468-75af-b214-5ed712f7e1a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1468-75af-b214-5ed712f7e1a2",
        "storage_key": "property/6767906449165604/019d2709-1468-75af-b214-5ed712f7e1a2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2843042972014026862&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "estadio-olmpico-benito-jurez",
      "poi_latitude": "31.7526757",
      "poi_longitude": "-106.4682618",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+52 656 612 7417",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-381f-7673-8ee8-4a6a8256f6ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-381f-7673-8ee8-4a6a8256f6ed",
        "storage_key": "property/6767906449165604/019d2709-381f-7673-8ee8-4a6a8256f6ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUR_bhxNZ54YRbiARHIWEdCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_fe47741a-8a36-494f-9616-16687004f98c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "El Paso County Coliseum",
      "poi_type": "Entertainment",
      "poi_address": "4100 E Paisano Dr, El Paso, TX 79905, USA",
      "poi_short_description": "Venue known for its many concerts and events, including monster trucks and a Van Gogh exhibit.",
      "poi_long_description": "People say this arena hosts awesome events like wrestling, rock concerts, and hockey games. They also highlight the fun and exciting atmosphere, and the good memories made at events.\n\nOther reviews mention the infrastructure can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-15b9-71f0-93d1-4f619a6369c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-15b9-71f0-93d1-4f619a6369c5",
        "storage_key": "property/6767906449165604/019d2709-15b9-71f0-93d1-4f619a6369c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://epcountycoliseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14120659578983158164&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-county-coliseum",
      "poi_latitude": "31.766561",
      "poi_longitude": "-106.4432224",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 915-534-4229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3798-730b-a09c-bc75d482095c",
        "storage_key": "property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ52jcy31Z54YRlBGClxKp9sM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_2c72d4e1-fa28-4a60-b179-fbdd2fd392b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Kinective Fitness Club",
      "poi_type": "Health and Wellness",
      "poi_address": "1020 Belvidere St, El Paso, TX 79912, USA",
      "poi_short_description": "Modern gym with state-of-the-art machines, spa amenities and fitness classes, plus personal training.",
      "poi_long_description": "People say this fitness center offers a wide variety of classes, including yoga, Pilates, cycling, and Zumba, and has state-of-the-art equipment, a rooftop track, and a rowing machine that emulates water. They highlight the clean and spacious facilities, the luxurious amenities such as a sauna, steam room, and massage beds, and the motivating and positive energy. They also like the friendly and helpful staff, and the sense of community.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-1528-72dd-8e52-312b2cd31600.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1528-72dd-8e52-312b2cd31600",
        "storage_key": "property/6767906449165604/019d2709-1528-72dd-8e52-312b2cd31600.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://kinective.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=844899700064661306&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kinective-fitness-club",
      "poi_latitude": "31.8521899",
      "poi_longitude": "-106.5401454",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-260-9895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3798-730b-a09c-bc75d482095c",
        "storage_key": "property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSrKKj753YYROi8w_cyvuQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_603eb902-b9ec-41cd-aa64-bf22f8c65edd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5700 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Chain gym with a variety of equipment, tanning, and massage services, plus 24-hour access.",
      "poi_long_description": "People say this gym offers a variety of equipment, including weight machines, free weights, and an abdomen room. They also highlight the convenient locations, clean facilities, and friendly staff.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-1982-77be-97f4-446646d4a5f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1982-77be-97f4-446646d4a5f8",
        "storage_key": "property/6767906449165604/019d2709-1982-77be-97f4-446646d4a5f8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/el-paso-mesa-hills-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=6859376139751605018&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "31.8241974",
      "poi_longitude": "-106.5208557",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 915-585-7867",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3798-730b-a09c-bc75d482095c",
        "storage_key": "property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bh0xehX54YRGkOvrkFmMV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a9cde1b4-4683-4245-97a1-bb2eac5192d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "TruFit Athletic Clubs - Sunland Mall",
      "poi_type": "Health and Wellness",
      "poi_address": "750 Sunland Park Dr Suite 101B, El Paso, TX 79912, USA",
      "poi_short_description": "Premium health club offering classes and training sessions in a welcoming atmosphere featuring fitness equipment and a turf area.",
      "poi_long_description": "People say this gym offers a wide variety of machines, free weights, and cardio equipment, as well as a women-only area and group fitness classes. They highlight the spacious, clean, and well-organized facility, and the friendly and comfortable atmosphere suitable for all fitness levels. They also like the helpful and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-19b6-77d8-9f42-ac17a93665d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-19b6-77d8-9f42-ac17a93665d4",
        "storage_key": "property/6767906449165604/019d2709-19b6-77d8-9f42-ac17a93665d4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://trufitathleticclubs.com/locations/tx/el-paso-sunland-park-mall/?utm_source=google&utm_medium=organic&utm_campaign=gmp",
      "poi_directions_map_url": "https://maps.google.com/?cid=15276080860203553813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trufit-athletic-clubs---sunland-mall",
      "poi_latitude": "31.8144216",
      "poi_longitude": "-106.5440443",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-300-1993",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3798-730b-a09c-bc75d482095c",
        "storage_key": "property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1_VFxT53YYRFZSTMJuK_9M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_94ceca25-7e45-4475-9613-90a5f4afa77b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "El Paso Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "6910 N Mesa St Ste H Suite D, El Paso, TX 79912, USA",
      "poi_short_description": "Gymnastics center with USA Gymnastics-certified coaches offering classes for all levels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-1964-7124-b01f-6bf0272ff2a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1964-7124-b01f-6bf0272ff2a7",
        "storage_key": "property/6767906449165604/019d2709-1964-7124-b01f-6bf0272ff2a7.webp",
        "width": 1008,
        "height": 567
      },
      "poi_business_url": "https://elpasogymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1102495125243281967&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-gymnastics",
      "poi_latitude": "31.8356392",
      "poi_longitude": "-106.5482103",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-581-3476",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-33e2-737e-a275-0555954f25e5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-33e2-737e-a275-0555954f25e5",
        "storage_key": "property/6767906449165604/019d2709-33e2-737e-a275-0555954f25e5.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg6HzWWX43YYRL8K5onnZTA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1e61fff3-5ea4-4a5f-9477-e69b54b54a32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "981 N Resler Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Gym chain with free weights and cardio machines, plus group fitness classes and saunas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-1a65-70b6-bbab-1c924e5a4e8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1a65-70b6-bbab-1c924e5a4e8d",
        "storage_key": "property/6767906449165604/019d2709-1a65-70b6-bbab-1c924e5a4e8d.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/tx/el-paso-resler/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7817928767867659509&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "31.86318139999999",
      "poi_longitude": "-106.5590516",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-760-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3798-730b-a09c-bc75d482095c",
        "storage_key": "property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ99A4Bwz53YYR9SQPEMvcfmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_f77f7026-a450-4a88-8c12-43bb63de3adb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "El Paso Animal Urgent Care West",
      "poi_type": "Health and Wellness",
      "poi_address": "5500 N Desert Blvd, El Paso, TX 79912, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-1f86-716e-af74-451c4ad34606.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1f86-716e-af74-451c4ad34606",
        "storage_key": "property/6767906449165604/019d2709-1f86-716e-af74-451c4ad34606.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://elpasoanimalurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8021225143916288949&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-animal-urgent-care-west",
      "poi_latitude": "31.8592417",
      "poi_longitude": "-106.575303",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-301-0065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3798-730b-a09c-bc75d482095c",
        "storage_key": "property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW-crCu353YYRtduPJsUdUW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_27d7a39a-dece-4f71-b146-e89a78ba762c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Gimnasio Municipal Josué Neri Santos",
      "poi_type": "Health and Wellness",
      "poi_address": "Prof.ª María Martínez s/n, Centro, 32000 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-1e10-746c-aaa4-a74eb8bae5e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1e10-746c-aaa4-a74eb8bae5e2",
        "storage_key": "property/6767906449165604/019d2709-1e10-746c-aaa4-a74eb8bae5e2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4476679980438114226&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gimnasio-municipal-josu-neri-santos",
      "poi_latitude": "31.741728",
      "poi_longitude": "-106.4869251",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+52 656 239 5774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3798-730b-a09c-bc75d482095c",
        "storage_key": "property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD6cfhiBZ54YRss8dR7lcID4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0c8add21-1392-4000-9fe9-af2fffa86941",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Crossroads Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4910 Crossroads Dr, El Paso, TX 79922, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-1ecf-7243-9f8a-9433adef230c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1ecf-7243-9f8a-9433adef230c",
        "storage_key": "property/6767906449165604/019d2709-1ecf-7243-9f8a-9433adef230c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.xroadsvets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=684506271961471425&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crossroads-animal-hospital",
      "poi_latitude": "31.8389216",
      "poi_longitude": "-106.5776014",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-584-3459",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3798-730b-a09c-bc75d482095c",
        "storage_key": "property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVV9PE1T43YYRwVnK4tPafwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_e3e533c6-6609-4167-96c5-4e497409ecfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Las Palmas Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1801 N Oregon St, El Paso, TX 79902, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-1f51-777e-ab16-5fbb52b89939.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1f51-777e-ab16-5fbb52b89939",
        "storage_key": "property/6767906449165604/019d2709-1f51-777e-ab16-5fbb52b89939.webp",
        "width": 888,
        "height": 499
      },
      "poi_business_url": "https://laspalmasdelsolhealthcare.com/locations/las-palmas-medical-center/?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=7797277200056017172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "las-palmas-medical-center",
      "poi_latitude": "31.7699653",
      "poi_longitude": "-106.4987868",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 915-521-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-37fe-723e-8d7b-c06d8cc86c24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-37fe-723e-8d7b-c06d8cc86c24",
        "storage_key": "property/6767906449165604/019d2709-37fe-723e-8d7b-c06d8cc86c24.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJa3k-QVdY54YRFGGXPE1-NWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_9b08d4f1-3570-48f1-a595-47ffc3273e2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "El Paso Children’s Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4845 Alameda Ave, El Paso, TX 79905, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-22b3-7565-90de-6f093640f06c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-22b3-7565-90de-6f093640f06c",
        "storage_key": "property/6767906449165604/019d2709-22b3-7565-90de-6f093640f06c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://elpasochildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17164696348058008125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-childrens-hospital",
      "poi_latitude": "31.7716769",
      "poi_longitude": "-106.433967",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 915-298-5444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-37fe-723e-8d7b-c06d8cc86c24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-37fe-723e-8d7b-c06d8cc86c24",
        "storage_key": "property/6767906449165604/019d2709-37fe-723e-8d7b-c06d8cc86c24.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4zuGd9Nb54YRPTpx12JANe4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c3c6d016-08d9-4bed-823c-740d2a247656",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Franklin Mountains State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2900 Tom Mays Park Access Rd, El Paso, TX 79911, USA",
      "poi_short_description": "24,247 acres of scenic desert offering climbing, hiking, wildlife, camping & views.",
      "poi_long_description": "People say this state park offers beautiful hiking trails, caves, and stunning views of the surrounding landscape. They highlight the peaceful and serene atmosphere, and the well-maintained trails suitable for all skill levels. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-2401-75c7-a7c1-bd8ba286a4d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2401-75c7-a7c1-bd8ba286a4d2",
        "storage_key": "property/6767906449165604/019d2709-2401-75c7-a7c1-bd8ba286a4d2.webp",
        "width": 1280,
        "height": 962
      },
      "poi_business_url": "https://tpwd.texas.gov/state-parks/franklin-mountains",
      "poi_directions_map_url": "https://maps.google.com/?cid=2199656840794880227&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "franklin-mountains-state-park",
      "poi_latitude": "31.9105609",
      "poi_longitude": "-106.518116",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 53 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 915-444-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3be2-70e9-96a7-2b3a60ec4a74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3be2-70e9-96a7-2b3a60ec4a74",
        "storage_key": "property/6767906449165604/019d2709-3be2-70e9-96a7-2b3a60ec4a74.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRc0ThtdV54YR4zhWDz7Ahh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_a2aff811-640e-419b-a1ee-0d747f62d999",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1701 N Copia St, El Paso, TX 79930, USA",
      "poi_short_description": "Community park with trails, lighted softball field, tennis courts, playground & a swimming pool.",
      "poi_long_description": "People say this city park offers beautiful trees, grassy hills, and a playground. They highlight the clean and well-maintained landscape, and the peaceful and relaxing atmosphere. They also like the shade provided by the trees, making it a great spot for picnics and outdoor activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-23f5-772c-bfdf-99f69cb3e8ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-23f5-772c-bfdf-99f69cb3e8ce",
        "storage_key": "property/6767906449165604/019d2709-23f5-772c-bfdf-99f69cb3e8ce.webp",
        "width": 1000,
        "height": 750
      },
      "poi_business_url": "http://www.elpasotexas.gov/parks-and-recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=615165719072263059&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "31.7894065",
      "poi_longitude": "-106.4571558",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3be2-70e9-96a7-2b3a60ec4a74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3be2-70e9-96a7-2b3a60ec4a74",
        "storage_key": "property/6767906449165604/019d2709-3be2-70e9-96a7-2b3a60ec4a74.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9_YWrJNZ54YRk8tMU_aBiQg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_7ac959a5-43ab-41bc-bc13-d66038044c28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Parque Público Federal El Chamizal",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Ing. David Herrera, C. Malecón, Chamizal, 32300 Juárez, Chih., Mexico",
      "poi_short_description": "Ceded by the US to Mexico in 1963, this green space is now a public park for sports & recreation.",
      "poi_long_description": "People say this park offers green areas, a museum, and opportunities for picnics, running, and outdoor sports. They highlight the tranquil and relaxing vibe, and the spacious areas suitable for family gatherings and activities. They also like the well-maintained grounds and the opportunity to interact with squirrels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-252d-77b8-a601-1d80a1a23af9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-252d-77b8-a601-1d80a1a23af9",
        "storage_key": "property/6767906449165604/019d2709-252d-77b8-a601-1d80a1a23af9.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16119446820157355735&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "parque-pblico-federal-el-chamizal",
      "poi_latitude": "31.7554974",
      "poi_longitude": "-106.4596892",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3be2-70e9-96a7-2b3a60ec4a74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3be2-70e9-96a7-2b3a60ec4a74",
        "storage_key": "property/6767906449165604/019d2709-3be2-70e9-96a7-2b3a60ec4a74.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb9BqGmxZ54YR13ZHe3rHs98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_437faa11-410b-4d52-838c-b4eec63a82a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "DIF Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Av. Heroico Colegio Militar s/n, Chamizal, 32300 Juárez, Chih., Mexico",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a variety of attractions, including a Christmas village with lights, a train ride, and a skating rink. They highlight the family-friendly atmosphere and the fun activities for children. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-28db-728a-add7-a3402d670b78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-28db-728a-add7-a3402d670b78",
        "storage_key": "property/6767906449165604/019d2709-28db-728a-add7-a3402d670b78.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5530219233310207241&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dif-park",
      "poi_latitude": "31.7514945",
      "poi_longitude": "-106.4652985",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3be2-70e9-96a7-2b3a60ec4a74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3be2-70e9-96a7-2b3a60ec4a74",
        "storage_key": "property/6767906449165604/019d2709-3be2-70e9-96a7-2b3a60ec4a74.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVfTwxRZ54YRCe18oxdJv0w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_448cd7f4-14be-416c-a0c5-dd442111a064",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Chamizal National Memorial",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "800 S San Marcial St, El Paso, TX 79905, USA",
      "poi_short_description": "55-acre park is home to a U.S.-Mexico-border museum & an amphitheater, plus a visitors center.",
      "poi_long_description": "People say this memorial park offers beautiful walking trails, scenic views of the mountains, and a cultural center with historical exhibits. They highlight the free entry, peaceful and relaxing vibe, and the well-maintained grounds. They also like the helpful and enthusiastic park rangers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-28a9-733d-b344-72a53296f43b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-28a9-733d-b344-72a53296f43b",
        "storage_key": "property/6767906449165604/019d2709-28a9-733d-b344-72a53296f43b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.nps.gov/cham/index.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=3141076655758003265&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chamizal-national-memorial",
      "poi_latitude": "31.7672409",
      "poi_longitude": "-106.4543374",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 915-532-7273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3be2-70e9-96a7-2b3a60ec4a74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3be2-70e9-96a7-2b3a60ec4a74",
        "storage_key": "property/6767906449165604/019d2709-3be2-70e9-96a7-2b3a60ec4a74.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwoGGHdZ54YRQUy6hpNYlys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e32ac796-d140-46ef-9c83-f7083558c29f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "El Paso, Texas",
      "poi_type": "Transportation & Transit",
      "poi_address": "700 W San Francisco Ave, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-29dd-7356-af1d-9fc289dfd403.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-29dd-7356-af1d-9fc289dfd403",
        "storage_key": "property/6767906449165604/019d2709-29dd-7356-af1d-9fc289dfd403.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=ELP",
      "poi_directions_map_url": "https://maps.google.com/?cid=17091980658630256344&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-texas",
      "poi_latitude": "31.75779249999999",
      "poi_longitude": "-106.4959672",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3b59-767e-aa12-ee8bd959e630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3b59-767e-aa12-ee8bd959e630",
        "storage_key": "property/6767906449165604/019d2709-3b59-767e-aa12-ee8bd959e630.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8VMdftY54YR2OaAEdrpMu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_b533a4bc-f69d-49e7-98c1-dec812511fca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "El Paso City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 N Campbell St, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-29cf-7023-913a-57a1e09fa158.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-29cf-7023-913a-57a1e09fa158",
        "storage_key": "property/6767906449165604/019d2709-29cf-7023-913a-57a1e09fa158.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.elpasotexas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7004826674061616697&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "el-paso-city-hall",
      "poi_latitude": "31.7618251",
      "poi_longitude": "-106.4853072",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 915-212-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3798-730b-a09c-c08b9a98ae3e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3798-730b-a09c-c08b9a98ae3e",
        "storage_key": "property/6767906449165604/019d2709-3798-730b-a09c-c08b9a98ae3e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI8RKcPxY54YROaafNL8kNmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_c7d3ec4f-95f6-4079-a846-618332560105",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "ACS Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2494 Ricker Rd, El Paso, TX 79925, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-2e0b-75b7-bdcf-33bf600b4a3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2e0b-75b7-bdcf-33bf600b4a3c",
        "storage_key": "property/6767906449165604/019d2709-2e0b-75b7-bdcf-33bf600b4a3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bliss.armymwr.com/programs/army-community-service",
      "poi_directions_map_url": "https://maps.google.com/?cid=15641003975660933022&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "acs-building",
      "poi_latitude": "31.808537",
      "poi_longitude": "-106.4167551",
      "poi_miles_from_property": "10.8",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 915-569-4227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3798-730b-a09c-bc75d482095c",
        "storage_key": "property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF2nL5o5b54YRng--Cz8CENk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d1b1d097-d76c-482c-ae13-2b84b881e18b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "WestStar Tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "601 N Mesa St, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-2e18-7276-8c8d-2ce21f3caef1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2e18-7276-8c8d-2ce21f3caef1",
        "storage_key": "property/6767906449165604/019d2709-2e18-7276-8c8d-2ce21f3caef1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.weststartower.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17936696281012297070&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "weststar-tower",
      "poi_latitude": "31.7619103",
      "poi_longitude": "-106.4902384",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-532-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3798-730b-a09c-bc75d482095c",
        "storage_key": "property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0X5dzG9Z54YRbt3OITzy6_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cbf4fbb3-708b-41d5-9f66-7c393c723c28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "1 Civic Center Plaza",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Civic Center Plaza, El Paso, TX 79901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-2e86-71a8-a809-1e11a9ac495a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2e86-71a8-a809-1e11a9ac495a",
        "storage_key": "property/6767906449165604/019d2709-2e86-71a8-a809-1e11a9ac495a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12352449684385399443&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "1-civic-center-plaza",
      "poi_latitude": "31.7576845",
      "poi_longitude": "-106.4917571",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3798-730b-a09c-bc75d482095c",
        "storage_key": "property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVV8fxY54YRk4Ktt4q3bKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_91ebb5cc-bdfb-46d5-ba59-747af1a84cf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "TransPerfect Connect",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1015 Belvidere St, El Paso, TX 79912, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-2f7f-774d-aae2-896be3211046.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-2f7f-774d-aae2-896be3211046",
        "storage_key": "property/6767906449165604/019d2709-2f7f-774d-aae2-896be3211046.webp",
        "width": 1280,
        "height": 740
      },
      "poi_business_url": "https://www.transperfectconnect.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17503557915821498174&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "transperfect-connect",
      "poi_latitude": "31.8540386",
      "poi_longitude": "-106.5409878",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 915-289-9425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-3798-730b-a09c-bc75d482095c",
        "storage_key": "property/6767906449165604/019d2709-3798-730b-a09c-bc75d482095c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGydw0WT53YYRPl8Exi8h6fI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_342cb2b3-fefb-47cc-b4be-78abcccf5d91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Dr. Green Elementary School",
      "poi_type": "Education",
      "poi_address": "5430 Buckley Dr, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-3899-73df-a550-cac2006d6161.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3899-73df-a550-cac2006d6161",
        "storage_key": "property/6767906449165604/019d7912-3899-73df-a550-cac2006d6161.webp",
        "width": 1280,
        "height": 507
      },
      "poi_business_url": "https://www.episd.org/o/gres",
      "poi_directions_map_url": "https://maps.google.com/?cid=17283601174716929722&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dr-green-elementary-school",
      "poi_latitude": "31.822663",
      "poi_longitude": "-106.511893",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-236-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b01c-7364-b3a8-b4c22f182b4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b01c-7364-b3a8-b4c22f182b4a",
        "storage_key": "property/6767906449165604/019cfb3f-b01c-7364-b3a8-b4c22f182b4a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF_WoxuxX54YRutaGKrKv2-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_58564dca-5238-4999-9a1c-06218b04cd62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Coronado High School",
      "poi_type": "Education",
      "poi_address": "100 Champions Pl, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-387a-719e-88c1-54fab2bf5d18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-387a-719e-88c1-54fab2bf5d18",
        "storage_key": "property/6767906449165604/019d7912-387a-719e-88c1-54fab2bf5d18.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://coronado.episd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14130504508255682606&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "coronado-high-school",
      "poi_latitude": "31.8370723",
      "poi_longitude": "-106.5467083",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 915-236-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b01c-7364-b3a8-b4c22f182b4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b01c-7364-b3a8-b4c22f182b4a",
        "storage_key": "property/6767906449165604/019cfb3f-b01c-7364-b3a8-b4c22f182b4a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCSIuemX43YYRLsCiz_uiGcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_a4651cc6-ee78-4961-80b9-cf443686242f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "El Paso Community College - Rio Grande Campus - EPCC RG",
      "poi_type": "Education",
      "poi_address": "100 W Rio Grande Ave, El Paso, TX 79902, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-3737-737a-b74c-924e72f7b381.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3737-737a-b74c-924e72f7b381",
        "storage_key": "property/6767906449165604/019d7912-3737-737a-b74c-924e72f7b381.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://epcc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9387787273262637608&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-paso-community-college-rio-grande-campus-epcc-rg",
      "poi_latitude": "31.763854",
      "poi_longitude": "-106.493823",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 915-831-3722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b01c-7364-b3a8-b4c22f182b4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b01c-7364-b3a8-b4c22f182b4a",
        "storage_key": "property/6767906449165604/019cfb3f-b01c-7364-b3a8-b4c22f182b4a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4VKH0vhY54YRKKLAUckeSII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_379e92fe-5b50-4b44-a08b-f8a91238f6e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "The University of Texas at El Paso",
      "poi_type": "Education",
      "poi_address": "3333 N Mesa St, El Paso, TX 79902, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.utep.edu/chs/pt/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15385263784180211019&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-texas-at-el-paso",
      "poi_latitude": "31.7831287",
      "poi_longitude": "-106.5067634",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-747-8207",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b01c-7364-b3a8-b4c22f182b4a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b01c-7364-b3a8-b4c22f182b4a",
        "storage_key": "property/6767906449165604/019cfb3f-b01c-7364-b3a8-b4c22f182b4a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzfwroGBZ54YRS12-p-Vvg9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_4fa05894-95dc-4740-995e-b500dff9215e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Villa Del Mar",
      "poi_type": "Restaurants",
      "poi_address": "5668 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Long-running seafood restaurant in Festival Hills offering Mexican fare alongside beer, wine, and cocktails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-3800-74da-a9c4-dba3b127576c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3800-74da-a9c4-dba3b127576c",
        "storage_key": "property/6767906449165604/019d7912-3800-74da-a9c4-dba3b127576c.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://villadelmarrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7438895923686357098&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "villa-del-mar",
      "poi_latitude": "31.8225351",
      "poi_longitude": "-106.519788",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-584-1888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b01e-77df-bee0-5a8f4d1a84ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b01e-77df-bee0-5a8f4d1a84ac",
        "storage_key": "property/6767906449165604/019cfb3f-b01e-77df-bee0-5a8f4d1a84ac.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9Zv4KO9X54YRajht_G1EPGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_eb985752-761b-4198-8b3b-044f89dfad2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Garufa Restaurante Argentino - Cd. Juárez",
      "poi_type": "Restaurants",
      "poi_address": "Bulevar Tomás Fernández 7671, Los Cisnes, Col Los Parques, 32440 Juárez, Chih., Mexico",
      "poi_short_description": "false",
      "poi_long_description": "People say this Argentinian restaurant serves delicious grilled meats, empanadas, and mollejas. They also highlight the relaxing and sophisticated atmosphere, and the attentive and professional service.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-422f-7281-a0c5-c55f8deeb57d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-422f-7281-a0c5-c55f8deeb57d",
        "storage_key": "property/6767906449165604/019d7912-422f-7281-a0c5-c55f8deeb57d.webp",
        "width": 1080,
        "height": 864
      },
      "poi_business_url": "http://www.garufajuarez.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8686012625733464008&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "garufa-restaurante-argentino-cd-ju-rez",
      "poi_latitude": "31.7319761",
      "poi_longitude": "-106.4117989",
      "poi_miles_from_property": "11.3 mi",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+52 656 625 9772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b01e-77df-bee0-5a8f4d1a84ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b01e-77df-bee0-5a8f4d1a84ac",
        "storage_key": "property/6767906449165604/019cfb3f-b01e-77df-bee0-5a8f4d1a84ac.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgxsj-3Vc54YRyK9mb3bqing",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "argentinian_restaurant"
    },
    {
      "id": "custom_cd31d420-b96b-4f9b-ba4c-ee2a6d5c84e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Koze Teppan Grill",
      "poi_type": "Restaurants",
      "poi_address": "6127 N Mesa St B, El Paso, TX 79912, USA",
      "poi_short_description": "Chefs grill meats & veggies tableside at this lively Japanese spot also offering sushi & cocktails.",
      "poi_long_description": "Diners say this bar and grill offers great portion sizes and delicious food, including the Bento box and New York steak with shrimp. They also highlight the reasonable prices, especially compared to other local establishments.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-48be-7248-9a26-c1e594a562e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-48be-7248-9a26-c1e594a562e9",
        "storage_key": "property/6767906449165604/019d7912-48be-7248-9a26-c1e594a562e9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kozeteppangrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5815450502152114703&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "koze-teppan-grill",
      "poi_latitude": "31.8308127",
      "poi_longitude": "-106.5322486",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-584-1128",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-abfc-74a9-aca5-2aea75ac255f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-abfc-74a9-aca5-2aea75ac255f",
        "storage_key": "property/6767906449165604/019d7912-abfc-74a9-aca5-2aea75ac255f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_5VHt9X54YRD9KkjWuhtFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_2a303d12-0011-4aee-bb41-a921ac000465",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Entrecôte & Co.",
      "poi_type": "Restaurants",
      "poi_address": "5825 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Upscale steakhouse serving French fare, plus wine, cocktails and beer in a cozy setting.",
      "poi_long_description": "People say this restaurant serves delicious French cuisine, including escargot, Chilean sea bass, and steak. They highlight the attentive and friendly staff, and the upscale yet relaxed atmosphere. They also like the great wine selection and the complimentary champagne and cake for special occasions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-4a6c-70a6-8ebb-bff0ff0963ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4a6c-70a6-8ebb-bff0ff0963ed",
        "storage_key": "property/6767906449165604/019d7912-4a6c-70a6-8ebb-bff0ff0963ed.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://entrecotebistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14255218939255702019&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "entrec-te-co",
      "poi_latitude": "31.8247658",
      "poi_longitude": "-106.524366",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 915-300-0022",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b01e-77df-bee0-5a8f4d1a84ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b01e-77df-bee0-5a8f4d1a84ac",
        "storage_key": "property/6767906449165604/019cfb3f-b01e-77df-bee0-5a8f4d1a84ac.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7-qvu3pX54YRA8LBDRm21MU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_27a109ea-85d3-4b60-91b8-9e59b0e0eb7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Thyme Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "5857 N Mesa St #24, El Paso, TX 79912, USA",
      "poi_short_description": "Eclectic New American dishes & cocktails in an elegant space with a mezzanine & patio.",
      "poi_long_description": "People say this New American restaurant serves delicious food, including scallops, duck, and beef medallions. They highlight the sophisticated atmosphere, extensive wine cellar, and attentive staff. They also like the friendly and professional service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-4b16-7337-87d7-478540f95855.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4b16-7337-87d7-478540f95855",
        "storage_key": "property/6767906449165604/019d7912-4b16-7337-87d7-478540f95855.webp",
        "width": 709,
        "height": 870
      },
      "poi_business_url": "https://www.thymerestaurantep.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10626591408354507174&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "thyme-restaurant",
      "poi_latitude": "31.826515",
      "poi_longitude": "-106.526716",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 915-585-0309",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b01e-77df-bee0-5a8f4d1a84ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b01e-77df-bee0-5a8f4d1a84ac",
        "storage_key": "property/6767906449165604/019cfb3f-b01e-77df-bee0-5a8f4d1a84ac.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHY9VcedX54YRpjkwdJU8eZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_2fb4bf24-c88d-4c22-ab12-5f9798665a20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Burritos Crisostomo - MESA",
      "poi_type": "Restaurants",
      "poi_address": "5658 N Mesa St # 17, El Paso, TX 79912, USA",
      "poi_short_description": "Mini-chain drive-thru taco stand serving up Juarez-style burritos with many filling options.",
      "poi_long_description": "People say this Mexican restaurant offers fresh tortillas, good burritos, and tasty salsa. They also highlight the affordable prices, clean facility, and convenient drive-through option.\n\nOther reviews mention the burritos can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-5015-73cb-85b1-7de00759e850.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5015-73cb-85b1-7de00759e850",
        "storage_key": "property/6767906449165604/019d7912-5015-73cb-85b1-7de00759e850.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.burritocrisostomo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4346580838022740211&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "burritos-crisostomo-mesa",
      "poi_latitude": "31.82148219999999",
      "poi_longitude": "-106.5185895",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 915-307-5356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b01e-77df-bee0-5a8f4d1a84ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b01e-77df-bee0-5a8f4d1a84ac",
        "storage_key": "property/6767906449165604/019cfb3f-b01e-77df-bee0-5a8f4d1a84ac.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx0_8ke5X54YR83jdNT4oUjw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_dd485672-acee-4d09-955b-5b3d30950b7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Verde Salad Co.",
      "poi_type": "Restaurants",
      "poi_address": "5809 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Casual eatery with a salad bar offering create-your-own bowls with a variety of toppings.",
      "poi_long_description": "People say this salad shop offers fresh vegetables, wraps, and salads with vegetarian, fish, and meat options. They also highlight the quick service, friendly staff, and the option to dine inside or on the patio.\n\nOther reviews mention the service can be rushed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-5ac7-7379-9119-226890c1874d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5ac7-7379-9119-226890c1874d",
        "storage_key": "property/6767906449165604/019d7912-5ac7-7379-9119-226890c1874d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://verdesalad.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18424860157774709765&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "verde-salad-co",
      "poi_latitude": "31.8243947",
      "poi_longitude": "-106.5239863",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 915-529-2828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b01e-77df-bee0-5a8f4d1a84ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b01e-77df-bee0-5a8f4d1a84ac",
        "storage_key": "property/6767906449165604/019cfb3f-b01e-77df-bee0-5a8f4d1a84ac.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRRqUS7lX54YRBcRoxLFAsv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "salad_shop"
    },
    {
      "id": "custom_35344db3-c0d1-4341-a435-ebc36f292056",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Another Broken Egg Cafe",
      "poi_type": "Restaurants",
      "poi_address": "5863 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "Casual chain featuring egg dishes & other breakfast items, plus brunch sandwiches.",
      "poi_long_description": "People say this brunch restaurant serves delicious omelets, pancakes, and biscuits and gravy. They highlight the generous portions, tasty food, and the friendly, attentive service. They also like the lively atmosphere and the quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-579f-724f-a4d4-d6d979da3c58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-579f-724f-a4d4-d6d979da3c58",
        "storage_key": "property/6767906449165604/019d7912-579f-724f-a4d4-d6d979da3c58.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.anotherbrokenegg.com/locations/el-paso-tx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5264478115464516937&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "another-broken-egg-cafe",
      "poi_latitude": "31.8279051",
      "poi_longitude": "-106.5273734",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-261-7551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b01e-77df-bee0-5a8f4d1a84ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b01e-77df-bee0-5a8f4d1a84ac",
        "storage_key": "property/6767906449165604/019cfb3f-b01e-77df-bee0-5a8f4d1a84ac.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX0zJZ2BX54YRSZUUIPQuD0k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_c81b965d-5bfd-4282-b03e-354e5487337e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Wake and Bake",
      "poi_type": "Restaurants",
      "poi_address": "5001 N Mesa St Building 2 Suite A, El Paso, TX 79912, USA",
      "poi_short_description": "Coffeehouse with a dispensary offering beverages, pastries, and edibles, as well as plants and live music.",
      "poi_long_description": "People say this coffee shop offers delicious coffee, matcha, pastries, and food, including a tiramisu latte with caramel cold foam and a turkey pesto panini. They highlight the relaxing and inviting atmosphere, and the friendly and knowledgeable staff. They also like the sustainable practices and the management's passion for the business.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-6648-754c-89d1-3ab6429581c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6648-754c-89d1-3ab6429581c1",
        "storage_key": "property/6767906449165604/019d7912-6648-754c-89d1-3ab6429581c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wakebakeelpaso.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5387675305403192398&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "wake-and-bake",
      "poi_latitude": "31.8119696",
      "poi_longitude": "-106.5129086",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 915-304-8269",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-ac2b-741d-a65f-1f726daa98b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-ac2b-741d-a65f-1f726daa98b6",
        "storage_key": "property/6767906449165604/019d7912-ac2b-741d-a65f-1f726daa98b6.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJqaCjImZX54YRTpSzJyXexEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_71f2f312-32ed-4602-8537-4a1b3616e18a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Teapioca Lounge",
      "poi_type": "Restaurants",
      "poi_address": "140 Montecillo Blvd Suites A3, El Paso, TX 79912, USA",
      "poi_short_description": "Modern hangout with a wide range of cream teas, coffee & smoothies, plus desserts & board games.",
      "poi_long_description": "People say this bubble tea store serves delicious Thai Tea Boba and strawberry banana smoothies with boba. They also highlight the friendly and fast service, and the great music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-68e9-7507-a29c-b54cf98bea90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-68e9-7507-a29c-b54cf98bea90",
        "storage_key": "property/6767906449165604/019d7912-68e9-7507-a29c-b54cf98bea90.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.teapiocalounge.com/teapioca-montecillo-el-paso-boba-tea",
      "poi_directions_map_url": "https://maps.google.com/?cid=12295184890857028125&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "teapioca-lounge",
      "poi_latitude": "31.8084173",
      "poi_longitude": "-106.514309",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-600-5841",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b02d-71a8-88e1-62160248f652",
        "storage_key": "property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU5WSAu9X54YRHXpI-4NFoao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tea_house"
    },
    {
      "id": "custom_ae691826-3b07-4b39-9fc3-038729b4e97b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Sushi Garden",
      "poi_type": "Restaurants",
      "poi_address": "5435 N Mesa St A, El Paso, TX 79912, USA",
      "poi_short_description": "This open-air restaurant offers sushi & Japanese grill options served in a casual, leafy space.",
      "poi_long_description": "People say this sushi restaurant offers delicious and fresh sushi, with some mentioning the salmon is particularly good. They highlight the affordable prices and pleasant dining experience. They also like the intimate and calm atmosphere, and the quick seating and service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-6fb9-74e4-a7d0-9ee06976d9c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-6fb9-74e4-a7d0-9ee06976d9c1",
        "storage_key": "property/6767906449165604/019d7912-6fb9-74e4-a7d0-9ee06976d9c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sushigardenep.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9248101010271884621&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sushi-garden",
      "poi_latitude": "31.8195135",
      "poi_longitude": "-106.5182449",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 915-307-2122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b01e-77df-bee0-5a8f4d1a84ac.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b01e-77df-bee0-5a8f4d1a84ac",
        "storage_key": "property/6767906449165604/019cfb3f-b01e-77df-bee0-5a8f4d1a84ac.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cKpbO5X54YRTdUvzN7aV4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_1ac357c3-602d-4d87-8666-878a8a4eb41f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Coronado Shopping Center",
      "poi_type": "Restaurants",
      "poi_address": "5905 N Mesa St, El Paso, TX 79912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-72fc-70af-8ae4-b6697acc45b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-72fc-70af-8ae4-b6697acc45b6",
        "storage_key": "property/6767906449165604/019d7912-72fc-70af-8ae4-b6697acc45b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12549446340279395017&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "coronado-shopping-center",
      "poi_latitude": "31.8289035",
      "poi_longitude": "-106.5285746",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b027-7229-83cb-f082f8d2217f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b027-7229-83cb-f082f8d2217f",
        "storage_key": "property/6767906449165604/019cfb3f-b027-7229-83cb-f082f8d2217f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIxU5QEtX54YRyeIt6PSWKK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_8fa920a5-7ffa-465f-abaf-512a1f0ce0f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Bob-O's Family Fun Center",
      "poi_type": "Entertainment",
      "poi_address": "3851 Constitution Dr, El Paso, TX 79922, USA",
      "poi_short_description": "Amusement venue with laser tag, go-karts, bumper boats, batting cages, an arcade, snacks & more.",
      "poi_long_description": "People say this amusement center offers a variety of fun activities, including go-karts, bumper boats, laser tag, and arcade games. They also highlight the reasonable prices and friendly, accommodating staff.\n\nOther reviews mention some games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-7424-70f1-8755-f78185d3408a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7424-70f1-8755-f78185d3408a",
        "storage_key": "property/6767906449165604/019d7912-7424-70f1-8755-f78185d3408a.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://bobosfun.com/?utm_source=gmb&utm_medium=organic&utm_campaign=elpaso",
      "poi_directions_map_url": "https://maps.google.com/?cid=18166085088815833051&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bob-o-s-family-fun-center",
      "poi_latitude": "31.8126125",
      "poi_longitude": "-106.5540313",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 915-587-6070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b02d-71a8-88e1-62160248f652",
        "storage_key": "property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa-acwxn43YYR219j5iPmGvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_a82df5f4-192a-4caa-bfaa-6dc5fbfe4b2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Keystone Heritage Park and the El Paso Desert Botanical Garden",
      "poi_type": "Entertainment",
      "poi_address": "4200 Doniphan Dr, El Paso, TX 79922, USA",
      "poi_short_description": "This 52-acre park features botanical gardens, wetlands & the remains of an ancient village.",
      "poi_long_description": "People say this botanical garden offers beautiful, tranquil, and well-maintained nature trails, a thriving pond filled with bird life, and a maze. They highlight the peaceful and relaxing atmosphere, and the opportunity to learn about the historic Rio Grande Del Norte and the local flora and fauna. They also like the affordable entry fee and the availability of shade and seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-7ed5-76d2-a24c-761028a66f28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7ed5-76d2-a24c-761028a66f28",
        "storage_key": "property/6767906449165604/019d7912-7ed5-76d2-a24c-761028a66f28.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.keystoneheritagepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12019324138855344271&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "keystone-heritage-park-and-the-el-paso-desert-botanical-garden",
      "poi_latitude": "31.820571",
      "poi_longitude": "-106.563529",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 915-490-8571",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b02d-71a8-88e1-62160248f652",
        "storage_key": "property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfzjy2D743YYRjyjAiJ83zaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_8a0e4869-5ded-414f-ae67-620c38c0fb9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Franklin Mountains State Park",
      "poi_type": "Entertainment",
      "poi_address": "Thunderbird Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Hiking area offering shade trees, sunset views, and a grilling area.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-868d-74e2-9280-e85163ff3722.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-868d-74e2-9280-e85163ff3722",
        "storage_key": "property/6767906449165604/019d7912-868d-74e2-9280-e85163ff3722.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3261171865648773583&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "franklin-mountains-state-park",
      "poi_latitude": "31.8513961",
      "poi_longitude": "-106.5098828",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b02d-71a8-88e1-62160248f652",
        "storage_key": "property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs0EHk0pW54YRzzl-i4gCQi0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_ddfb4bca-7486-4013-8dd3-50fa3a5c9c82",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Thousand Steps Trailhead",
      "poi_type": "Entertainment",
      "poi_address": "4999 N Stanton St, El Paso, TX 79902, USA",
      "poi_short_description": "Popular trail featuring rocky terrain, caves and views of El Paso, plus airplane wreckage.",
      "poi_long_description": "People say this hiking area offers beautiful views and a variety of trails suitable for different skill levels. They highlight the trails are dog-friendly, and the trailhead is well-equipped with amenities such as a water fountain, picnic tables, and tools for bicyclists. They also like the convenient access and the honor box payment system.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-82bb-762d-8803-2262fd4f9468.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-82bb-762d-8803-2262fd4f9468",
        "storage_key": "property/6767906449165604/019d7912-82bb-762d-8803-2262fd4f9468.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elpasotexas.gov/parks/parks-planning/trails-and-trailheads/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5674331233262067202&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "thousand-steps-trailhead",
      "poi_latitude": "31.8077772",
      "poi_longitude": "-106.5000008",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b02d-71a8-88e1-62160248f652",
        "storage_key": "property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-0eF2ydY54YRAl59WDFGv04",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_c614bf5d-56dc-453d-995a-502c11ca0d15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "McKelligon Canyon",
      "poi_type": "Entertainment",
      "poi_address": "McKelligon Canyon Rd, El Paso, TX 79930, USA",
      "poi_short_description": "Shaded picnic tables and a cave at this desert park featuring trails, an amphitheater and a show.",
      "poi_long_description": "People say this amphitheatre offers a cool place to watch concerts, with good food and drinks. They highlight the beautiful mountain and city views, and the relaxing and quiet vibe. They also like the challenging hills for hiking and training, and the easy access.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-81d9-77c9-b17c-dbbb9b56e2c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-81d9-77c9-b17c-dbbb9b56e2c2",
        "storage_key": "property/6767906449165604/019d7912-81d9-77c9-b17c-dbbb9b56e2c2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://elpasolive.com/venues/mckelligon-canyon-amphitheatre",
      "poi_directions_map_url": "https://maps.google.com/?cid=17692196788310998967&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mckelligon-canyon",
      "poi_latitude": "31.8375278",
      "poi_longitude": "-106.4846943",
      "poi_miles_from_property": "10.3 mi",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 915-534-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b02d-71a8-88e1-62160248f652",
        "storage_key": "property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbeBU7mZX54YRt3-V3z1Ph_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "custom_19c7fd33-7b9e-44fc-bb45-fb722f6dea8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "El Paso Municipal Rose Garden",
      "poi_type": "Entertainment",
      "poi_address": "3418 Aurora Ave, El Paso, TX 79930, USA",
      "poi_short_description": "Peaceful oasis featuring different varieties of roses and other flowers, with benches and a fountain.",
      "poi_long_description": "People say this garden offers a large selection of award-winning roses and other flowers. They highlight the peaceful and serene atmosphere, and the beautiful aroma. They also like the well-maintained grounds and the availability of shade and covered seating. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-942e-72fa-abaa-084bafa25901.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-942e-72fa-abaa-084bafa25901",
        "storage_key": "property/6767906449165604/019d7912-942e-72fa-abaa-084bafa25901.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elpasotexas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16475470708097522831&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-paso-municipal-rose-garden",
      "poi_latitude": "31.7928257",
      "poi_longitude": "-106.4530369",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 915-212-0092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b02d-71a8-88e1-62160248f652",
        "storage_key": "property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT37fuJJZ54YRj5yBd1GhpOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_e15727a6-4cd9-486a-bc8a-9387a873da89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "801 S Mesa Hills Dr, El Paso, TX 79912, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including trampolines, obstacle courses, and laser tag. They also highlight the friendly and helpful staff, and the clean and safe environment.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-9101-728b-ba6f-7774e27943c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9101-728b-ba6f-7774e27943c8",
        "storage_key": "property/6767906449165604/019d7912-9101-728b-ba6f-7774e27943c8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/texas-west-el-paso/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=9791591556466300534&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "31.81827539999999",
      "poi_longitude": "-106.5405754",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 915-263-8277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b02d-71a8-88e1-62160248f652",
        "storage_key": "property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2yyOdb53YYRdlbjfKS44oc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_9f6b0058-00fe-4d2a-8005-411ef0d38467",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Sunland Park Racetrack & Casino",
      "poi_type": "Entertainment",
      "poi_address": "1200 Futurity Dr, Sunland Park, NM 88063, USA",
      "poi_short_description": "Entertainment complex featuring a track for horse racing, casino with slots & 2 restaurants.",
      "poi_long_description": "People say this casino offers a variety of gambling options, including slots, video poker, electronic table games, and horse racing. They also highlight the friendly and helpful staff, and the fun and exciting atmosphere.\n\nOther reviews mention the casino can be smoky.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-9869-75ce-a351-a9773ee3cee8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9869-75ce-a351-a9773ee3cee8",
        "storage_key": "property/6767906449165604/019d7912-9869-75ce-a351-a9773ee3cee8.webp",
        "width": 537,
        "height": 420
      },
      "poi_business_url": "http://www.sunland-park.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10680450856454078792&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sunland-park-racetrack-casino",
      "poi_latitude": "31.8048639",
      "poi_longitude": "-106.5598271",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 575-874-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3f-b02d-71a8-88e1-62160248f652",
        "storage_key": "property/6767906449165604/019cfb3f-b02d-71a8-88e1-62160248f652.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn9ClnCH43YYRSEH2a3eVOJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_b07938ab-dbf6-451a-89e3-d97e7ff37295",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "El Paso Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "1 Arts Festival Plaza, El Paso, TX 79901, USA",
      "poi_short_description": "Works in 5 galleries reflect the area's American, Mexican & European roots.",
      "poi_long_description": "People say this museum offers a unique and diverse art experience, with some great historical pieces and student art. They highlight the free admission and the well-maintained, clean space. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-9af0-728d-b827-a4728c3c4263.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-9af0-728d-b827-a4728c3c4263",
        "storage_key": "property/6767906449165604/019d7912-9af0-728d-b827-a4728c3c4263.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://epma.art/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17054373816264367256&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-paso-museum-of-art",
      "poi_latitude": "31.7585876",
      "poi_longitude": "-106.4902692",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 915-212-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019d7912-addd-77cd-bdcd-45d0d73300ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-addd-77cd-bdcd-45d0d73300ad",
        "storage_key": "property/6767906449165604/019d7912-addd-77cd-bdcd-45d0d73300ad.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJuxWj_B1Z54YRmBwpwaBOrew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_b4eb265f-0173-4588-b800-1660502df3fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Charles Q. Murphree PK-8",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "charles-q-murphree-pk-8",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a7d1e019-fa0e-4207-ba3a-23a75996fdfb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Shops on Mesa",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "shops-on-mesa",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7b1d3ef9-d9e5-41e3-be2e-7b9e297e144f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Cave Climbing Gym",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "cave-climbing-gym",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ba6a2251-2248-4965-88b7-5f8639143a19",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "iFLY Indoor Skydiving El Paso",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "ifly-indoor-skydiving-el-paso",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_20852421-3a0d-43ae-aada-daaa68b7fb04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "poi_name": "Alamo Drafthouse Cinema Montecillo",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "alamo-drafthouse-cinema-montecillo",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_2bcc95c6c917fdcce4f9c531",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_499c082825a74422ee423eba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ea125a2e1ee45a109c9bf5ab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_00be4bd19a3740d6331d5ef6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_a2ea814d08a71028e14fb3b9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_aebc3bcd4f24581f6a7b2b7f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_71d49fcf88c721df60a70f7e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "rating": "5",
      "name": "Chris Durham",
      "text": "Office staff and Maintenance team was great. Maintenance repaired the staircase in a few hours. No issues !",
      "date": "2025-11-29",
      "title": "false"
    },
    {
      "id": "ec_63d5b5d3f1a5b4b06972f59f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "rating": "5",
      "name": "Cynthia Kitty",
      "text": "The staff is always amicable,  and professional, not only with me but with my fur baby. I've resided here for over 11 years n maintenance is always prompt. I can go on and on of how great it is to live at DoubleTree. Thank you for all that you do!!",
      "date": "2026-01-05",
      "title": "false"
    },
    {
      "id": "ec_80d3f149ea8d442fdee68dc2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "rating": "5",
      "name": "Bak Solomon",
      "text": "I had problem with AC. Water leaking. Very fast and professional maintenance. I called leasing office and they took care of everything.",
      "date": "2025-10-05",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_38cc5d04-609f-4c0b-a69f-aab66ff57115",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb40-1c1b-70df-851f-cfc158d7402a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of the outdoor swimming pool with lounge chairs.",
        "public_id": "019cfb40-1c1b-70df-851f-cfc158d7402a",
        "storage_key": "property/6767906449165604/019cfb40-1c1b-70df-851f-cfc158d7402a.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Double Tree Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f69a3460e00e62cf941ae41&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-31ff-75d9-a99b-33d85a21315d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "double-tree-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604"
    },
    {
      "lead_collector_id": "019cf79e-3272-75ec-bff4-d9b41c603a68",
      "lead_source": "LANDING_PAGE",
      "name": "double-tree-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-el-paso",
      "search_query": "pet friendly apartments in El Paso",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in El Paso",
      "h2_subtitle": "Discover the best pet friendly apartments in El Paso today. Enjoy luxurious amenities and a welcoming community at Double Tree Apts.",
      "page_copy": "Double Tree Apts. welcomes you and your furry companions to El Paso’s most friendly community. Nestled conveniently in Upper Mesa Hills, our pet friendly apartments offer an ideal blend of comfort and accessibility. Whether you’re lounging by the pool or exploring nearby walking trails with your pet, there's something here for everyone. We proudly provide spacious one and two-bedroom layouts that cater to all lifestyles, ensuring both you and your pets feel right at home. Plus, with amenities like a refreshing sundeck and onsite laundry facilities, convenience is always at your fingertips.\n\nEmbrace vibrant community living with exclusive access to planned social activities and a business center that supports work-life balance. The Double Tree Apts. location ensures easy access to public transportation, making it hassle-free to venture with your pets around El Paso. With flexible payment options and a pet-friendly policy, our apartments stand out as the perfect choice for pet owners seeking a home in the heart of Texas.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-7419-715f-9daa-35f61053b79d.webp",
      "featured_image_media": {
        "alt_text": "Reception desk with chairs and seating area in community office.",
        "public_id": "019cfb3f-7419-715f-9daa-35f61053b79d",
        "storage_key": "property/6767906449165604/019cfb3f-7419-715f-9daa-35f61053b79d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in El Paso",
      "seo_description": "Find pet friendly apartments in El Paso at Double Tree Apts. Enjoy luxury living with your pets in our spacious community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "generator",
      "page_item_url": "apartments-with-pool-upper-mesa-hills",
      "search_query": "apartments with a pool in Upper Mesa Hills",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Upper Mesa Hills",
      "h2_subtitle": "Experience the best apartments with a pool in Upper Mesa Hills. Enjoy community life at Double Tree Apts.",
      "page_copy": "Dive into a refreshing lifestyle at Double Tree Apts., where apartments with a pool in Upper Mesa Hills await you. Our spacious one and two-bedroom layouts are nestled in a vibrant community that balances convenience and comfort. Soak up the sun on our inviting sundeck and take a dip in our sparkling pool, perfect for relaxation and unwinding after a long day.\n\nLocated in the scenic Upper Mesa Hills of El Paso, our community offers more than just a pool. Residents enjoy premium amenities such as an onsite business center, onsite laundry facilities, and easy access to public transportation, making everyday life effortless. With planned social activities, super-fast internet powered by AT&T, and flexible payment options, Double Tree Apts. is designed to meet all your needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-7419-715f-9daa-35f61053b79d.webp",
      "featured_image_media": {
        "alt_text": "Reception desk with chairs and seating area in community office.",
        "public_id": "019cfb3f-7419-715f-9daa-35f61053b79d",
        "storage_key": "property/6767906449165604/019cfb3f-7419-715f-9daa-35f61053b79d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Upper Mesa Hills",
      "seo_description": "Discover apartments with a pool in Upper Mesa Hills at Double Tree Apts. Enjoy luxurious amenities and a vibrant community life.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "generator",
      "page_item_url": "spacious-floorplans-el-paso-tx",
      "search_query": "spacious floorplans El Paso TX",
      "category": "Amenity",
      "h1_title": "Spacious Floorplans in El Paso, TX",
      "h2_subtitle": "Explore spacious floorplans in El Paso, TX at Double Tree Apts. Find the perfect layout that fits your lifestyle.",
      "page_copy": "At Double Tree Apts., spacious floorplans in El Paso, TX are designed to provide comfort and luxury. Choose from our thoughtfully designed one or two-bedroom layouts that offer ample living space, perfect for residents who value a blend of style and functionality. Whether you're relaxing or entertaining, our floorplans cater to all lifestyles and needs, ensuring each resident feels at home.\n\nLocated in Upper Mesa Hills, Double Tree Apts. combines convenience with a community-oriented environment. Residents enjoy premium amenities such as a sparkling pool, sundeck, and business center, making it easy to balance work and play. With pet-friendly policies, flexible payment options, and easy access to public transportation, our community is ideal for those seeking a dynamic living experience in El Paso.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-7419-715f-9daa-35f61053b79d.webp",
      "featured_image_media": {
        "alt_text": "Reception desk with chairs and seating area in community office.",
        "public_id": "019cfb3f-7419-715f-9daa-35f61053b79d",
        "storage_key": "property/6767906449165604/019cfb3f-7419-715f-9daa-35f61053b79d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Floorplans in El Paso, TX",
      "seo_description": "Find spacious floorplans in El Paso, TX at Double Tree Apts. Enjoy luxurious living with ample space and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "generator",
      "page_item_url": "apartments-near-fort-bliss-el-paso",
      "search_query": "apartments near Fort Bliss",
      "category": "Amenity",
      "h1_title": "Apartments Near Fort Bliss",
      "h2_subtitle": "Discover ideal apartments near Fort Bliss in El Paso. Double Tree Apts. offers comfort and convenience just minutes away.",
      "page_copy": "For those seeking apartments near Fort Bliss, Double Tree Apts. offers a perfect solution with a prime location in El Paso. Situated in Upper Mesa Hills, our community is just a short drive from Fort Bliss, providing easy access for military personnel and their families. Enjoy the convenience of a vibrant community that balances comfort with accessibility, featuring spacious one and two-bedroom apartments.\n\nAt Double Tree Apts., residents enjoy a host of premium amenities designed to enhance lifestyle living. These include a sparkling pool, inviting sundeck, and an onsite business center. Our pet-friendly community also features flexible payment options and is well-connected to public transportation, making it easy to navigate the city. Embrace community life with planned social activities and nearby walking trails, all designed with our residents in mind.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-7419-715f-9daa-35f61053b79d.webp",
      "featured_image_media": {
        "alt_text": "Reception desk with chairs and seating area in community office.",
        "public_id": "019cfb3f-7419-715f-9daa-35f61053b79d",
        "storage_key": "property/6767906449165604/019cfb3f-7419-715f-9daa-35f61053b79d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Fort Bliss",
      "seo_description": "Looking for apartments near Fort Bliss? Discover Double Tree Apts. in El Paso, offering convenience and premium community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "generator",
      "page_item_url": "apartments-fully-equipped-kitchens-el-paso",
      "search_query": "apartments with fully equipped kitchens El Paso",
      "category": "Amenity",
      "h1_title": "Apartments with Fully Equipped Kitchens",
      "h2_subtitle": "Discover apartments with fully equipped kitchens in El Paso. Double Tree Apts. offers modern living spaces and premium amenities.",
      "page_copy": "At Double Tree Apts., find the best apartments with fully equipped kitchens in El Paso, designed for modern living and culinary inspiration. Our spacious one and two-bedroom layouts feature kitchens outfitted with everything you need to create your favorite meals at home. Whether you're an aspiring chef or enjoy casual cooking, our kitchens offer the perfect blend of convenience and style.\n\nLocated in the desirable Upper Mesa Hills, Double Tree Apts. offers more than just well-equipped kitchens. Residents enjoy a comprehensive range of amenities including a refreshing pool, sundeck, and onsite business center. Pet-friendly and with flexible payment options, our community ensures all your needs are met. Additionally, our easy access to public transportation and nearby walking trails enriches your living experience in vibrant El Paso.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-7419-715f-9daa-35f61053b79d.webp",
      "featured_image_media": {
        "alt_text": "Reception desk with chairs and seating area in community office.",
        "public_id": "019cfb3f-7419-715f-9daa-35f61053b79d",
        "storage_key": "property/6767906449165604/019cfb3f-7419-715f-9daa-35f61053b79d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fully Equipped Kitchens",
      "seo_description": "Explore apartments with fully equipped kitchens in El Paso at Double Tree Apts. Enjoy modern living with premium amenities and community convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-el-paso-tx",
      "search_query": "one bedroom apartments el paso tx",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in El Paso, TX",
      "h2_subtitle": "Explore one bedroom apartments in El Paso, TX at Double Tree Apts. Experience comfort and style.",
      "page_copy": "Discover the perfect one bedroom apartments in El Paso, TX at Double Tree Apts., where comfort meets modern living. Our thoughtfully designed one-bedroom layouts provide a cozy and functional living space, with premium finishes and amenities that cater to your lifestyle needs. Whether you're a professional or a student, these apartments offer a serene environment suitable for rest and relaxation.\n\nLocated in the vibrant community of Upper Mesa Hills, Double Tree Apts. provides residents with a suite of amenities beyond the comfort of their apartments. Enjoy features such as our sparkling pool, relaxing sundeck, and convenient onsite business center. The community also offers flexible payment options, pet-friendly accommodations, and easy access to public transportation, ensuring a seamless living experience in the heart of El Paso.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-7419-715f-9daa-35f61053b79d.webp",
      "featured_image_media": {
        "alt_text": "Reception desk with chairs and seating area in community office.",
        "public_id": "019cfb3f-7419-715f-9daa-35f61053b79d",
        "storage_key": "property/6767906449165604/019cfb3f-7419-715f-9daa-35f61053b79d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in El Paso, TX",
      "seo_description": "Find stylish one bedroom apartments in El Paso, TX at Double Tree Apts. Enjoy comfortable living with premium amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165604",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-upper-mesa-hills",
      "search_query": "two bedroom apartments upper mesa hills",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Upper Mesa Hills",
      "h2_subtitle": "Find spacious two bedroom apartments in Upper Mesa Hills at Double Tree Apts. Enjoy convenient living with modern amenities.",
      "page_copy": "Welcome to Double Tree Apts., offering inviting two bedroom apartments in the coveted Upper Mesa Hills neighborhood of El Paso. Our well-designed layouts provide ample space, perfect for roommates, families, or those who simply desire extra room. Experience the ease of living in a vibrant community with essential amenities and modern conveniences at your doorstep.\n\nAt our community, residents enjoy a wide array of features, including a sparkling pool, relaxing sundeck, and an onsite business center ideal for working from home. We pride ourselves on being a pet-friendly complex with flexible payment options tailored to fit various needs. With easy access to public transportation and nearby walking trails, Double Tree Apts. provides an ideal blend of comfort and connectivity, all within the charm of Upper Mesa Hills.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165604/019cfb3f-7419-715f-9daa-35f61053b79d.webp",
      "featured_image_media": {
        "alt_text": "Reception desk with chairs and seating area in community office.",
        "public_id": "019cfb3f-7419-715f-9daa-35f61053b79d",
        "storage_key": "property/6767906449165604/019cfb3f-7419-715f-9daa-35f61053b79d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Upper Mesa Hills",
      "seo_description": "Explore spacious two bedroom apartments in Upper Mesa Hills at Double Tree Apts. Enjoy modern amenities and a convenient El Paso location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5173"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-XQY6K211FG"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151668"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/double-tree-apartments/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MMBGKJ9S"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165604/019d1bd8-1825-7009-b41c-62ee63479147.pdf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "833-642-3700"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6480cd6072e104ca3a287057"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkdXRXY4Y3gvWU1zVWY3aWRsQTdaaGc9PSIsInZhbHVlIjoiTnZmbEd0SGQrZ1Z5bGt3TUthLzNaUT09IiwibWFjIjoiMzU4ODQ4MzIxOTQ2YjQ0NGEwZGM0MTQwOTNjZmMzNGIyYTU0NmQ1NTA4OTMwMmU1ZjRlNjVhMGIxMDgwOTBhMiJ9"
    }
  ],
  "custom_qb_id": "5173",
  "custom_ga4_id": "G-XQY6K211FG",
  "custom_repli_id": "10041151668",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/double-tree-apartments/register/",
  "custom_google_gtm_id": "GTM-MMBGKJ9S",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165604/019d1bd8-1825-7009-b41c-62ee63479147.pdf",
  "custom_ppc_tracking_phone_number": "833-642-3700",
  "custom_residentboost_apartment_id": "6480cd6072e104ca3a287057",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkdXRXY4Y3gvWU1zVWY3aWRsQTdaaGc9PSIsInZhbHVlIjoiTnZmbEd0SGQrZ1Z5bGt3TUthLzNaUT09IiwibWFjIjoiMzU4ODQ4MzIxOTQ2YjQ0NGEwZGM0MTQwOTNjZmMzNGIyYTU0NmQ1NTA4OTMwMmU1ZjRlNjVhMGIxMDgwOTBhMiJ9"
};

export const generatedAt = '2026-08-27T21:38:20.436Z';
